import '../App.css'
import getApiBaseUrl from '../utils/apiConfig';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Accordion from 'react-bootstrap/Accordion';
import React from 'react';
import socketIO from "socket.io-client";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Linking } from 'react-native';
import ToggleSwitch from '../components/ToggleSwitch';
import TipDistributionModal from '../components/TipDistributionModal';
import SwapModal from '../components/SwapModal';
import SecureStorage from '../utils/SecureStorage';
const bip39 = require('bip39');
const hdkey = require('hdkey');
const bitcoreDoge = require('bitcore-lib-doge');
const litecore = require('litecore-lib');
const EC = require('elliptic').ec;
const ec = new EC('secp256k1');

export class Admin extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
      payments: [],
      storeId: 'Unset',
      storeName: '',  // Store name from backend
      wallets: [],
      tipsPool: [],
      apiKey: '',
      splash: 'default',
      fiatCurrency: 'USD',
      fiatSymbol: '$',
      hasWallet: false,
      walletLoading: true,
      showPayoutView: false,
      utxos: null,
      tips: {},
      totalSatoshis: 0,
      newTipAddress: '',
      retailerPayoutAddress: '',
      selectedCrypto: 'doge',
      btcWallet: null,
      ltcWallet: null,
      dogeWallet: null,
      payoutAddressDoge: '',
      payoutAddressBtc: '',
      payoutAddressLtc: '',
      showPayoutSettings: false,
      payoutPassword: '',

      // Employee tipping state
      showTipModal: false,
      eligibleEmployees: [],
      loadingEmployees: false,
      employeeTips: [],  // Will be passed to payout/calculate and payout/broadcast
      totalTipsAvailable: 0,  // Tip pool from payments.tip_amount (in DOGE/BTC/LTC)

      // Multi-tab detection
      sessionId: null,
      sessionWarningShown: false,

      // Import wallet modal state
      showImportModal: false,
      importCrypto: null,  // 'btc', 'ltc', or 'doge'
      importSeedPhrase: '',
      importPassword: '',
      importing: false,

      // Suspension status
      isSuspended: false,
      suspensionReason: '',
      suspendedAt: null,

      // Swap modal state
      showSwapModal: false,

      // Crypto balances (for swap modal)
      btcBalance: 0,
      ltcBalance: 0,
      dogeBalance: 0,

      // Retailer rewards state
      retailerRewards: null,
      loadingRetailerRewards: false,
      retailerRewardsError: null,
      // Personal wallet registration state
      personalWallets: [],
      loadingWallets: false,
      addingWallet: false,
      newWalletAddress: '',
      newWalletCrypto: 'doge',
      newWalletLabel: '',
      customerRewards: null,
      loadingCustomerRewards: false,
      // Responsive layout state
      isSmallScreen: typeof window !== 'undefined' ? window.innerWidth < 600 : false
		};

    this.handleClickWallet = this.handleClickWallet.bind(this)
    this.handleClickCloseOutDoge = this.handleClickCloseOutDoge.bind(this);
    this.handleClickStoreId = this.handleClickStoreId.bind(this)
    this.handleClickKey = this.handleClickKey.bind(this)
    this.handleClickMode = this.handleClickMode.bind(this)
    this.handleClickMerchantId = this.handleClickMerchantId.bind(this)
    this.handleClickCurrency = this.handleClickCurrency.bind(this);
    this.handleClickTipsMode = this.handleClickTipsMode.bind(this);
    this.handleClickTipOnlyMode = this.handleClickTipOnlyMode.bind(this);
    this.handleClickFeePassthrough = this.handleClickFeePassthrough.bind(this);
    this.handleClickDiscount = this.handleClickDiscount.bind(this);
    this.handleClickSplash = this.handleClickSplash.bind(this);
    this.handleSelectFiat = this.handleSelectFiat.bind(this);
    this.createWallet = this.createWallet.bind(this);
    this.handleImportSelectCrypto = this.handleImportSelectCrypto.bind(this);
    this.handleImportWallet = this.handleImportWallet.bind(this);
    this.checkWalletStatus = this.checkWalletStatus.bind(this);
    this.buildTransactionAutomatic = this.buildTransactionAutomatic.bind(this);
    this.fetchSettlementData = this.fetchSettlementData.bind(this);
    this.fetchPayments = this.fetchPayments.bind(this);
    this.handleAddTipAddress = this.handleAddTipAddress.bind(this);
    this.handleRemoveTipAddress = this.handleRemoveTipAddress.bind(this);
    this.handleWelcomeText = this.handleWelcomeText.bind(this);
    this.handleRetailerPayoutAddress = this.handleRetailerPayoutAddress.bind(this);
    this.handleSavePayoutAddresses = this.handleSavePayoutAddresses.bind(this);
    this.handleCryptoChange = this.handleCryptoChange.bind(this);
    this.fetchEligibleEmployees = this.fetchEligibleEmployees.bind(this);
    this.handleTipConfirm = this.handleTipConfirm.bind(this);
    this.handleTipSkip = this.handleTipSkip.bind(this);
    this.initializeSession = this.initializeSession.bind(this);
    this.checkSessionConflict = this.checkSessionConflict.bind(this);
    this.checkSuspensionStatus = this.checkSuspensionStatus.bind(this);
	}

  /**
   * Initialize session ID for multi-tab detection
   * Prevents data conflicts when multiple stores open simultaneously
   */
  async initializeSession() {
    // Generate unique session ID
    const sessionId = `session-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

    // Store in component state
    this.setState({ sessionId });

    // Store in AsyncStorage with store ID prefix to track which store owns this session
    const storeId = await AsyncStorage.getItem('store-id');
    await AsyncStorage.setItem('admin-session-id', sessionId);
    await AsyncStorage.setItem('admin-session-store-id', storeId || '');

    console.log(`📱 Session initialized: ${sessionId} for store ${storeId}`);

    // Start periodic session conflict check (every 2 seconds)
    this.sessionCheckInterval = setInterval(this.checkSessionConflict, 2000);
  }

  /**
   * Check if another tab/window has taken over the session
   * Warns user about potential data conflicts
   */
  async checkSessionConflict() {
    if (this.state.sessionWarningShown) {
      return; // Already warned, don't spam
    }

    try {
      const currentStorageSessionId = await AsyncStorage.getItem('admin-session-id');
      const currentStorageStoreId = await AsyncStorage.getItem('admin-session-store-id');
      const myStoreId = this.state.storeId;

      // Check if session ID changed (another tab took over)
      if (currentStorageSessionId !== this.state.sessionId) {
        console.warn('⚠️  Session conflict detected!');
        console.warn(`  My session: ${this.state.sessionId}`);
        console.warn(`  Storage session: ${currentStorageSessionId}`);
        console.warn(`  My store: ${myStoreId}`);
        console.warn(`  Storage store: ${currentStorageStoreId}`);

        this.setState({ sessionWarningShown: true });

        // Show warning to user
        window.alert(
          '⚠️ Multiple Stores Detected!\n\n' +
          'WARNING: You have multiple store admin pages open in different tabs.\n\n' +
          `This tab is for: ${myStoreId}\n` +
          `Another tab is for: ${currentStorageStoreId}\n\n` +
          'Having multiple stores open simultaneously can cause data conflicts, ' +
          'including wallet mixing and incorrect payment tracking.\n\n' +
          '🔒 RECOMMENDATION: Close all other admin tabs and refresh this page.\n\n' +
          'Only have ONE store admin page open at a time!'
        );

        // Stop checking after warning shown
        if (this.sessionCheckInterval) {
          clearInterval(this.sessionCheckInterval);
        }
      }
    } catch (error) {
      console.error('Error checking session conflict:', error);
    }
  }

  /**
   * Migrate existing AsyncStorage keys to SecureStorage
   * Run once on app startup to move plaintext keys to encrypted storage
   */
  async migrateToSecureStorage() {
    console.log('[Migration] Checking for keys to migrate...');

    try {
      // Check if password is available for encryption
      const password = await AsyncStorage.getItem('storePassword');

      if (!password) {
        console.warn('[Migration] ⚠️  No password available - skipping migration');
        console.warn('[Migration] Keys will remain in AsyncStorage until password is set');
        console.warn('[Migration] New wallets will use encrypted storage');
        return;
      }

      const cryptoKeys = ['btc', 'ltc', 'doge'];

      for (const crypto of cryptoKeys) {
        const oldKey = `api-key-${crypto}`;

        // Check if key exists in old AsyncStorage location
        const oldValue = await AsyncStorage.getItem(oldKey);

        if (oldValue) {
          console.log(`[Migration] Found old ${crypto.toUpperCase()} key in AsyncStorage`);

          // Check if already migrated to SecureStorage
          const alreadyMigrated = await SecureStorage.hasSecureItem(oldKey);

          if (!alreadyMigrated) {
            console.log(`[Migration] Migrating ${crypto.toUpperCase()} key to SecureStorage...`);

            // Store in encrypted storage with password
            await SecureStorage.setSecureItem(oldKey, oldValue, password);

            // Remove from plaintext storage
            await AsyncStorage.removeItem(oldKey);

            console.log(`[Migration] ✅ ${crypto.toUpperCase()} key migrated successfully`);
          } else {
            console.log(`[Migration] ${crypto.toUpperCase()} key already in SecureStorage, removing old plaintext`);
            // Still remove the old plaintext version
            await AsyncStorage.removeItem(oldKey);
          }
        }
      }

      console.log('[Migration] Migration complete!');
    } catch (error) {
      console.error('[Migration] Migration failed:', error);
      console.error('[Migration] Keys will remain in current location');
      // Don't throw - allow app to continue even if migration fails
    }
  }

  componentDidMount() {
    const checkAndSetConfig = async () => {
      const storeId = await AsyncStorage.getItem('store-id')
      const storeName = await AsyncStorage.getItem('store-name')

      // Check if store is activated (has Store ID)
      if (!storeId) {
        // Not activated - show message and redirect
        window.alert(
          'Store Not Activated\n\n' +
          'Please use your activation link to set up your store.\n\n' +
          'If you lost your activation link or need help, contact Dijitto support.'
        );
        // Redirect to home or request page
        if (typeof window !== 'undefined') {
          window.location.href = '/request';
        }
        return;
      }

      // Store is activated - proceed normally
      if (storeId) {
        this.setState({storeId, storeName: storeName || ''}, () => {
          this.fetchSettlementData();
          this.fetchPayments();
          this.fetchStoreData();
          this.checkSuspensionStatus();
          this.fetchRetailerRewards();
          this.fetchPersonalWallets();
        });
      }
      const keyPairs = [
        {storeKey: 'api-key', stateKey: 'apiKey'},
        {storeKey: 'posMode', stateKey: 'posMode'},
        {storeKey: 'merchantId', stateKey: 'merchantId'},
        {storeKey: 'tipsMode', stateKey: 'tipsMode'},
        {storeKey: 'tipOnlyMode', stateKey: 'tipOnlyMode'},
        {storeKey: 'feePassthrough', stateKey: 'feePassthrough'},
        {storeKey: 'discount', stateKey: 'discount'},
        {storeKey: 'splash', stateKey: 'splash'},
        {storeKey: 'fiatCurrency', stateKey: 'fiatCurrency'},
        {storeKey: 'fiatSymbol', stateKey: 'fiatSymbol'},
        {storeKey: 'topText', stateKey: 'topText'},
        {storeKey: 'middleText', stateKey: 'middleText'},
        {storeKey: 'bottomText', stateKey: 'bottomText'},
        {storeKey: 'retailerPayoutAddress', stateKey: 'retailerPayoutAddress'},
      ]
      for (var i = 0; i < keyPairs.length; i++) {
        var keyPair = keyPairs[i]
        const storeVal = await AsyncStorage.getItem(keyPair.storeKey)
        if (storeVal) {
          this.setState({[keyPair.stateKey]: storeVal})
        }
      }
    }
    checkAndSetConfig()
    this.migrateToSecureStorage() // Migrate old keys to encrypted storage
    this.checkWalletStatus()
    this.initializeSession() // Initialize multi-tab detection

    // Add resize listener for responsive layout
    this.handleResize = () => {
      this.setState({ isSmallScreen: window.innerWidth < 600 });
    };
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    // Clean up session check interval
    if (this.sessionCheckInterval) {
      clearInterval(this.sessionCheckInterval);
    }
    // Clean up resize listener
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }
  }

  handleClickWallet(wallet) {
    console.log('clicked wallet: ', wallet)
    if (this.state.tipsPool.includes(wallet)) {
      var tipsPool = [...this.state.tipsPool]
      var index = tipsPool.indexOf(wallet)
      if (index != -1) {
        tipsPool.splice(index, 1)
        this.setState({tipsPool})
      }
    } else {
      this.setState((state,props) => (
          {tipsPool: [...state.tipsPool, wallet]}
        )
      )
    }
  }

	async handleClickCloseOutDoge() {
		// CRITICAL: Check if payout address is set for selected cryptocurrency
		if (!this.hasPayoutAddressSet(this.state.selectedCrypto)) {
			window.alert(
				`⚠️ Payout Address Not Set\n\n` +
				`You must set a ${this.state.selectedCrypto.toUpperCase()} payout address before processing payouts.\n\n` +
				`Go to "Payout Address Settings" in the Admin section to configure your payout address.`
			);
			return;
		}

		// Step 1: Fetch settlement data (UTXOs and tips) for the selected crypto
		await this.fetchSettlementData();

		// Step 2: Check if there are tips to distribute
		if (this.state.totalTipsAvailable > 0) {
			// Fetch eligible employees for tip distribution
			await this.fetchEligibleEmployees();

			// Show tip distribution modal
			this.setState({ showTipModal: true });
		} else {
			// No tips - skip modal and proceed directly to payout
			this.setState({ employeeTips: [] }, () => {
				this.handleSignAndSendTransaction();
			});
		}
	}

	async handleSignAndSendTransaction() {
		try {
      await this.buildTransactionAutomatic();
			this.setState({ paid: true });
		} catch (error) {
			console.error('Error signing transaction:', error);
			window.alert(`Failed to sign and send transaction: ${error.message}`);
		}
	}

  async buildTransactionAutomatic() {
    console.log('=== Starting Automatic Transaction (BlockCypher API) ===');

    try {
      // Get stored xpriv for selected crypto (try encrypted storage first, fallback to plaintext)
      const cryptoKey = `api-key-${this.state.selectedCrypto}`;
      let storedXpriv = await SecureStorage.getSecureItem(cryptoKey);

      // Fallback to plaintext AsyncStorage if not found in SecureStorage
      if (!storedXpriv) {
        storedXpriv = await AsyncStorage.getItem(cryptoKey);
      }

      if (!storedXpriv) {
        throw new Error('No wallet found. Please create a wallet first.');
      }

      // Fetch payout calculation and transaction skeleton from backend
      const apiBase = getApiBaseUrl();
      console.log('Fetching transaction skeleton from backend...');
      const response = await fetch(`${apiBase}/payout/calculate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          store_id: this.state.storeId,
          crypto: this.state.selectedCrypto,
          employee_tips: this.state.employeeTips  // Include employee tips
        })
      });

      if (!response.ok) {
        const errorData = await response.json();

        // Check if this is a dust threshold error
        if (errorData.reason === 'dust_threshold') {
          const crypto = errorData.crypto || this.state.selectedCrypto.toUpperCase();
          const errorMsg =
            `${errorData.message}\n\n` +
            `Current Balance: ${errorData.current_balance?.toFixed(8) || 'Unknown'} ${crypto}\n` +
            `Minimum Required: ${errorData.minimum_required?.toFixed(8) || 'Unknown'} ${crypto}\n` +
            `Still Need: ${errorData.shortfall?.toFixed(8) || 'Unknown'} ${crypto}\n\n` +
            `Please wait for more payments to accumulate.`;

          throw new Error(errorMsg);
        }

        throw new Error(errorData.error || `Failed to calculate payout: ${response.statusText}`);
      }

      const payoutData = await response.json();

      if (!payoutData.ready_for_payout) {
        // Check if this is a dust threshold error (backup check)
        if (payoutData.reason === 'dust_threshold') {
          const crypto = payoutData.crypto || this.state.selectedCrypto.toUpperCase();
          const errorMsg =
            `${payoutData.message}\n\n` +
            `Current Balance: ${payoutData.current_balance?.toFixed(8) || 'Unknown'} ${crypto}\n` +
            `Minimum Required: ${payoutData.minimum_required?.toFixed(8) || 'Unknown'} ${crypto}\n` +
            `Still Need: ${payoutData.shortfall?.toFixed(8) || 'Unknown'} ${crypto}\n\n` +
            `Please wait for more payments to accumulate.`;

          throw new Error(errorMsg);
        }

        throw new Error(payoutData.message || 'No funds available for payout');
      }

      if (!payoutData.tx_skeleton) {
        throw new Error('Backend did not return transaction skeleton');
      }

      console.log('Payout data:', payoutData);
      console.log('Transaction skeleton received');
      console.log(`To sign: ${payoutData.tx_skeleton.tosign.length} hashes`);

      // Confirm with user
      const totalBalance = payoutData.total_collected_doge;
      const retailerAmount = payoutData.payout_distribution.find(d => d.recipient === 'Retailer')?.amount_doge || 0;
      const totalEmployeeTips = payoutData.total_employee_tips_doge || 0;

      // Service Fee = Total - Retailer - Employee Tips
      // (includes Dijitto fee, sales commission, network fees, etc.)
      const serviceFee = totalBalance - retailerAmount - totalEmployeeTips;

      let confirmMsg = `🔐 Process Automatic Payout\n\n` +
        `Total: ${totalBalance.toFixed(8)} ${payoutData.crypto}\n\n` +
        `Retailer: ${retailerAmount.toFixed(8)} ${payoutData.crypto}\n` +
        `Service Fee: ${serviceFee.toFixed(8)} ${payoutData.crypto}\n`;

      if (totalEmployeeTips > 0) {
        confirmMsg += `Employee Tips: ${totalEmployeeTips.toFixed(8)} ${payoutData.crypto}\n`;
      }

      confirmMsg += `\n\nThis will sweep all ${payoutData.crypto} from your wallet in one transaction.`;

      if (!window.confirm(confirmMsg)) {
        return;
      }

      console.log('Signing transaction hashes...');

      // Sign each hash with the corresponding private key
      const signatures = [];
      const pubkeys = [];

      // Handle Bitcoin and Litecoin BIP84 separately from DOGE
      if (this.state.selectedCrypto === 'btc' || this.state.selectedCrypto === 'ltc') {
        // Bitcoin/Litecoin BIP84 signing using hdkey library
        const cryptoName = this.state.selectedCrypto === 'btc' ? 'Bitcoin' : 'Litecoin';
        console.log(`Using BIP84 signing for ${cryptoName}...`);
        const accountNode = hdkey.fromExtendedKey(storedXpriv);

        // Set up network configuration
        const bitcoin = require('bitcoinjs-lib');
        let network;
        if (this.state.selectedCrypto === 'btc') {
          network = bitcoin.networks.bitcoin;
        } else {
          // Litecoin network config
          network = {
            messagePrefix: '\x19Litecoin Signed Message:\n',
            bech32: 'ltc',
            bip32: {
              public: 0x019da462,
              private: 0x019d9cfe,
            },
            pubKeyHash: 0x30,
            scriptHash: 0x32,
            wif: 0xb0,
          };
        }

        for (let i = 0; i < payoutData.signing_info.length; i++) {
          const sigInfo = payoutData.signing_info[i];
          const hashToSign = sigInfo.hash;
          const addressIndex = sigInfo.address_index;

          console.log(`Signing hash ${i+1}/${payoutData.signing_info.length}`);
          console.log(`  Address: ${sigInfo.address} (index ${addressIndex})`);
          console.log(`  Hash: ${hashToSign.substring(0, 16)}...`);

          // Derive key for this address: m/84'/X'/0'/0/{index} where X is 0 for BTC, 2 for LTC
          // accountNode is already at m/84'/X'/0', so derive m/84'/X'/0'/0/{index}
          const externalChain = accountNode.deriveChild(0); // m/84'/X'/0'/0
          const addressNode = externalChain.deriveChild(addressIndex); // m/84'/X'/0'/0/{index}

          const privateKey = addressNode.privateKey;
          const publicKey = addressNode.publicKey;

          // Verify address matches (BIP84 uses P2WPKH)
          const { address: derivedAddress } = bitcoin.payments.p2wpkh({
            pubkey: publicKey,
            network: network
          });

          console.log(`  Derived address: ${derivedAddress}`);
          console.log(`  Expected address: ${sigInfo.address}`);
          console.log(`  Match: ${derivedAddress === sigInfo.address}`);

          if (derivedAddress !== sigInfo.address) {
            throw new Error(`Address mismatch at index ${addressIndex}: derived ${derivedAddress}, expected ${sigInfo.address}`);
          }

          // Sign the hash using elliptic
          const privateKeyHex = privateKey.toString('hex');
          const keyPair = ec.keyFromPrivate(privateKeyHex, 'hex');
          const signature = keyPair.sign(hashToSign, 'hex', { canonical: true });
          const signatureHex = signature.toDER('hex') + '01'; // Append SIGHASH_ALL flag

          signatures.push(signatureHex);
          pubkeys.push(publicKey.toString('hex'));

          console.log(`  ✓ Signed input ${i+1}/${payoutData.signing_info.length}`);
        }

        console.log(`✅ All ${signatures.length} ${cryptoName} (BIP84) inputs signed`);

      } else {
        // Dogecoin signing using bitcore-lib-doge (supports both legacy and BIP44)
        if (this.state.selectedCrypto !== 'doge') {
          throw new Error(`Unsupported cryptocurrency: ${this.state.selectedCrypto}`);
        }

        console.log('Using Dogecoin signing (bitcore-lib-doge)...');

        const HDPrivateKey = bitcoreDoge.HDPrivateKey;
        const network = bitcoreDoge.Networks.livenet || bitcoreDoge.Networks.mainnet;
        const accountKey = HDPrivateKey.fromString(storedXpriv, network);

        for (let i = 0; i < payoutData.signing_info.length; i++) {
          const sigInfo = payoutData.signing_info[i];
          const hashToSign = sigInfo.hash;
          const addressIndex = sigInfo.address_index;

          console.log(`Signing hash ${i+1}/${payoutData.signing_info.length}`);
          console.log(`  Address: ${sigInfo.address} (index ${addressIndex})`);
          console.log(`  Hash: ${hashToSign.substring(0, 16)}...`);

          // Derive the private key for this address index
          // For BIP44: accountKey is at m/44'/3'/0', derive m/44'/3'/0'/0/{index}
          // For legacy: accountKey is at m/, derive m/0/{index}
          const externalChain = accountKey.deriveChild(0);  // External chain (0)
          const derivedKey = externalChain.deriveChild(addressIndex);  // Specific address
          const privateKey = derivedKey.privateKey;
          const publicKey = derivedKey.publicKey;

          // Verify derived address matches
          const derivedAddress = publicKey.toAddress(network).toString();
          console.log(`  Derived address: ${derivedAddress}`);
          console.log(`  Expected address: ${sigInfo.address}`);
          console.log(`  Match: ${derivedAddress === sigInfo.address}`);

          if (derivedAddress !== sigInfo.address) {
            throw new Error(`Address mismatch for index ${addressIndex}: derived ${derivedAddress}, expected ${sigInfo.address}`);
          }

          // Sign the hash using elliptic (browser-compatible)
          const privateKeyHex = privateKey.toString('hex');
          const keyPair = ec.keyFromPrivate(privateKeyHex, 'hex');
          const signature = keyPair.sign(hashToSign, 'hex', { canonical: true });
          const signatureHex = signature.toDER('hex');

          signatures.push(signatureHex);
          pubkeys.push(publicKey.toString('hex'));

          console.log(`  Signature: ${signatureHex.substring(0, 16)}...`);
          console.log(`  Public key: ${publicKey.toString('hex').substring(0, 16)}...`);
        }

        console.log(`✅ All ${signatures.length} hashes signed successfully`);
      }

      // Broadcast transaction via backend
      console.log('Broadcasting transaction...');
      const broadcastResponse = await fetch(`${apiBase}/payout/broadcast`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tx_skeleton: payoutData.tx_skeleton,
          signatures: signatures,
          pubkeys: pubkeys,
          store_id: this.state.storeId,
          crypto: this.state.selectedCrypto,
          employee_tips: this.state.employeeTips,  // Include employee tips (CRITICAL!)
          // Include sales commission data from calculate response
          sales_commission_enabled: payoutData.sales_commission_enabled,
          sales_commission_amount: payoutData.sales_commission_amount,
          sales_rep_config: payoutData.sales_rep_config
        })
      });

      if (!broadcastResponse.ok) {
        const errorData = await broadcastResponse.json();

        // Check if this is a dust error
        if (errorData.reason === 'dust') {
          throw new Error(
            `⚠️ ${errorData.error}\n\n` +
            `${errorData.message}\n\n` +
            `Technical details: ${errorData.technicalDetails}`
          );
        }

        // Generic error
        throw new Error(`Broadcast failed: ${errorData.error || broadcastResponse.statusText}`);
      }

      const broadcastData = await broadcastResponse.json();
      const txHash = broadcastData.tx_hash;

      console.log('✅ Transaction broadcast successful!');
      console.log('Transaction hash:', txHash);
      console.log('Zout ID:', broadcastData.zout_id);

      // Record close-out timestamp in database
      try {
        console.log('Recording close-out timestamp...');
        const closeoutResponse = await fetch(`${apiBase}/stores/${this.state.storeId}/closeout/${this.state.selectedCrypto}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            transaction_hash: txHash,
            amount: payoutData.total_collected_doge
          })
        });

        if (closeoutResponse.ok) {
          const closeoutData = await closeoutResponse.json();
          console.log('✅ Close-out timestamp recorded:', closeoutData);
        } else {
          console.error('Failed to record close-out timestamp:', closeoutResponse.statusText);
        }
      } catch (closeoutError) {
        console.error('Error recording close-out timestamp:', closeoutError);
        // Don't fail the entire operation if timestamp recording fails
      }

      // Refresh settlement data
      await this.fetchSettlementData();
      await this.fetchPayments();

      // Show simple success message
      const successMsg = `✅ Payout Successful!\n\n` +
        `Transaction Hash:\n${txHash}\n\n` +
        `Amount: ${payoutData.total_collected_doge.toFixed(8)} ${payoutData.crypto}\n\n` +
        `The transaction has been broadcast to the network.`;

      window.alert(successMsg);

      this.setState({ paid: true });

    } catch (error) {
      console.error('Automatic payout failed:', error);
      throw error;
    }
  }

  async buildTransactionManual() {
    console.log('=== Starting buildTransaction (Retailer-Controlled Wallet System) ===');

    try {

        // Fetch payout calculation from new endpoint
        console.log('Fetching payout calculation...');
        const apiBase = getApiBaseUrl();
        const payoutUrl = `${apiBase}/payout/calculate`;

        const response = await fetch(payoutUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                store_id: this.state.storeId,
                crypto: this.state.selectedCrypto,
                employee_tips: this.state.employeeTips  // Include employee tips
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const payoutData = await response.json();
        console.log('Payout calculation received:', {
            totalDoge: payoutData.total_collected_doge,
            distributionCount: payoutData.payout_distribution?.length,
            readyForPayout: payoutData.ready_for_payout
        });

        if (!payoutData.ready_for_payout) {
            throw new Error(payoutData.message || 'No funds available for payout');
        }

        // Confirm payout with user
        const payoutSummary = payoutData.payout_distribution.map(d =>
            `- ${d.amount_doge.toFixed(8)} DOGE to ${d.description} (${d.address})`
        ).join('\n');

        const estimatedFee = payoutData.estimated_network_fee || 100000;
        var ok = window.confirm(
            `Payout will distribute ${payoutData.total_collected_doge.toFixed(8)} DOGE:\n\n` +
            'See console for payout details' + '\n\n' +
            `- ${(estimatedFee / 100000000).toFixed(8)} DOGE network processing fee\n\n` +
            `Continue with payout?`
        );

        if (!ok) {
            return;
        }

        // In retailer-controlled system, we display transaction details for manual processing
        console.log('=== RETAILER-CONTROLLED PAYOUT ===');
        console.log('Transaction must be created and signed by retailer using their secure wallet');
        console.log('Payout Distribution:');
        payoutData.payout_distribution.forEach(d => {
            console.log(`  ${d.recipient}: ${d.amount_doge.toFixed(8)} DOGE -> ${d.address}`);
        });

        // Show instructions to retailer with actual payout details
        const payoutDetailsText = payoutData.payout_distribution.map(d =>
            `  • ${d.amount_doge.toFixed(8)} ${payoutData.crypto} to ${d.recipient}\n    ${d.address}`
        ).join('\n\n');

        window.alert(
            `RETAILER-CONTROLLED PAYOUT INSTRUCTIONS:\n\n` +
            `Total to distribute: ${payoutData.total_collected_doge.toFixed(8)} ${payoutData.crypto}\n\n` +
            `Please use your secure wallet to create a transaction with these outputs:\n\n` +
            payoutDetailsText + '\n\n' +
            `Estimated network fee: ${(estimatedFee / 100000000).toFixed(8)} ${payoutData.crypto}\n\n` +
            `Once you broadcast the transaction, you'll need to provide the transaction ID (TXID) to complete the payout.`
        );

        // Prompt for transaction ID
        const txid = window.prompt(
            'Enter the transaction ID (TXID) from your wallet after broadcasting the payout transaction:'
        );

        if (!txid) {
            console.log('Payout cancelled - no transaction ID provided');
            return;
        }

        // Validate TXID format
        const txidRegex = /^[a-fA-F0-9]{64}$/;
        if (!txidRegex.test(txid)) {
            throw new Error(`Invalid transaction ID format: ${txid}`);
        }

        console.log('Processing payout completion with TXID:', txid);

        // Mark payout as completed
        const completeResponse = await fetch(`${apiBase}/payout/complete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                store_id: this.state.storeId,
                transaction_hash: txid,
                crypto: this.state.selectedCrypto
            })
        });

        if (!completeResponse.ok) {
            throw new Error(`Failed to complete payout: ${completeResponse.statusText}`);
        }

        const completeResult = await completeResponse.json();
        console.log('Payout marked as completed:', completeResult);

        // Record close-out timestamp in database
        try {
          console.log('Recording close-out timestamp...');
          const closeoutResponse = await fetch(`${apiBase}/stores/${this.state.storeId}/closeout/${this.state.selectedCrypto}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              transaction_hash: txid,
              amount: payoutData.total_collected_doge
            })
          });

          if (closeoutResponse.ok) {
            const closeoutData = await closeoutResponse.json();
            console.log('✅ Close-out timestamp recorded:', closeoutData);
          } else {
            console.error('Failed to record close-out timestamp:', closeoutResponse.statusText);
          }
        } catch (closeoutError) {
          console.error('Error recording close-out timestamp:', closeoutError);
          // Don't fail the entire operation if timestamp recording fails
        }

        // Refresh data
        this.fetchSettlementData();
        this.fetchPayments();

        window.alert(`Payout completed successfully!\n\nTransaction ID: ${txid}\nUpdated ${completeResult.updated_transactions || 0} transactions.`);
    } catch (error) {
        console.error('Failed to settle balance:', error);
        window.alert(`Failed to settle balance: ${error.message}`);
        throw error;
    }
  }

  renderPayoutView() {
    return (
        <div>
            <div className="admin-section">
                <h3>Z Report</h3>
                <div className="z-report">
                    <div className="report-header">
                        <div>{this.state.selectedCrypto.toUpperCase()} PAYOUT DETAILS</div>
                        <div>{new Date().toDateString()}</div>
                    </div>
                    <hr/>
                    <div className="report-row">
                        <span>Total {this.state.selectedCrypto.toUpperCase()} Collected</span>
                        <span>Ɖ{this.collected().toFixed(8)}</span>
                    </div>
                    {this.state.tipsMode !== 'false' && this.state.totalTipsAvailable > 0 && (
                        <>
                            <div className="report-row">
                                <span>Tips Collected</span>
                                <span>Ɖ{this.state.totalTipsAvailable.toFixed(8)}</span>
                            </div>
                            {/* Show individual employee tip breakdown if tips were distributed */}
                            {this.state.employeeTips && this.state.employeeTips.length > 0 && (
                                <div style={{ paddingLeft: '20px', fontSize: '14px', color: '#6c757d' }}>
                                    {this.state.employeeTips.map((empTip, idx) => (
                                        <div key={idx} className="report-row" style={{ fontSize: '13px' }}>
                                            <span>• {empTip.employee_name}</span>
                                            <span>Ɖ{empTip.tip_amount.toFixed(8)}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </>
                    )}
                    <div className="report-row">
                        <span>Estimated Service Fee ({(this.state.dijittoFeePercentage || 2.50).toFixed(2)}%)</span>
                        <span>Ɖ{this.serviceFee().toFixed(8)}</span>
                    </div>
                    <hr/>
                    <div className="report-row">
                        <span>Retail Payout (less any transaction fees/tips)</span>
                        <span>Ɖ{this.payoutAmount().toFixed(8)}</span>
                    </div>
                    <div className="report-actions">
                        <button onClick={() => this.handleSignAndSendTransaction()}>
                            Sign & Send Transaction
                        </button>
                        <button onClick={() => this.setState({ showPayoutView: false })}>
                            Back to Admin
                        </button>
                    </div>
                    {this.state.paid && (
                        <div className="paid-status">Paid</div>
                    )}
                </div>
            </div>
        </div>
    );
  }

  async handleClickStoreId() {
    const key = 'store-id'
    const value2 = window.prompt('Please enter your store identifier')

    if (!value2 || value2.trim() === '') {
        window.alert('Store ID is required. Please enter a valid Store ID.');
        return;
    }

    // If user entered a Store ID, proceed with validation
    {
        // If changing to a different store ID, clear old wallet keys
        const currentStoreId = await AsyncStorage.getItem(key);
        if (currentStoreId && currentStoreId !== value2) {
            // Clear wallet keys and xpubs when switching Store IDs
            await AsyncStorage.removeItem('api-key-btc');
            await AsyncStorage.removeItem('api-key-ltc');
            await AsyncStorage.removeItem('api-key-doge');
            await AsyncStorage.removeItem('api-key'); // legacy key
            await AsyncStorage.removeItem('api-xpub-btc');
            await AsyncStorage.removeItem('api-xpub-ltc');
            await AsyncStorage.removeItem('api-xpub-doge');
        }

        // Verify store exists and is active in backend database
        try {
            const apiBase = getApiBaseUrl();
            const response = await fetch(`${apiBase}/stores/${value2}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (response.status === 403) {
                // Store exists but is not active
                const data = await response.json();
                window.alert(
                    `Store Access Denied\n\n` +
                    `${data.message || 'This store is not active.'}\n\n` +
                    `If you need to create a new store or reactivate this one, ` +
                    `please contact Ðijitto support.`
                );
                return;
            }

            if (response.status === 404) {
                // Store doesn't exist
                window.alert(
                    `Store Not Found\n\n` +
                    `The store ID "${value2}" does not exist in the system.\n\n` +
                    `To create a new store, please contact Ðijitto owner/support. ` +
                    `New stores must be approved before they can be used.`
                );
                return;
            }

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.success && data.store) {
                // Store exists and is active
                console.log('Connected to active store:', data.store);
                const storeName = data.store.store_name || '';

                // Check if this is first-time login on this device
                const isFirstLogin = currentStoreId !== value2;

                if (isFirstLogin) {
                    // Require password for first-time setup
                    const password = window.prompt(
                        `Password Required\n\n` +
                        `Enter your store password (provided during approval):`
                    );

                    if (!password) {
                        window.alert('Password is required to access this store.');
                        return;
                    }

                    // Verify password with backend
                    const verifyResponse = await fetch(`${apiBase}/stores/${value2}/verify-password`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ password })
                    });

                    if (!verifyResponse.ok) {
                        const verifyData = await verifyResponse.json();
                        window.alert(
                            `Password Verification Failed\n\n` +
                            `${verifyData.error || 'Invalid password'}\n\n` +
                            `Please contact support if you forgot your password.`
                        );
                        return;
                    }

                    const verifyData = await verifyResponse.json();

                    if (!verifyData.valid) {
                        window.alert(
                            `Incorrect Password\n\n` +
                            `The password you entered is incorrect.\n\n` +
                            `Please contact support if you forgot your password.`
                        );
                        return;
                    }

                    // Store password for encryption (encrypted storage will use this)
                    await AsyncStorage.setItem('storePassword', password);
                    console.log('✅ Password verified and stored for encryption');
                }

                // Store ID and name
                await AsyncStorage.setItem(key, value2);
                await AsyncStorage.setItem('store-name', storeName);
                this.setState({storeId: value2, storeName: storeName}, () => {
                    this.fetchSettlementData();
                });
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            console.error('Error checking store in database:', error);
            window.alert(
                `Error Connecting to Store\n\n` +
                `Could not verify store status: ${error.message}\n\n` +
                `Please check your connection and try again.`
            );
        }
    }

    this.checkWalletStatus();
  }

  handleClickKey() {
    const key = 'api-key';
    let value2 = window.prompt('Enter seed phrase, or type "new" and click OK to create new wallet. Enter a dot by itself to reset.', this.state.apiKey || '')
    if (value2 && value2.length > 0) {
      if (value2 === '.') {
        value2 = '';
      }
      AsyncStorage.setItem(key,value2);
      this.setState({apiKey: value2});
    }
    if (value2 === 'new') {
      console.log('create wallet')
      this.createWallet();
      console.log('wallet created')
    }
  }

  handleClickMode(e) {
    let posMode = e.target.name;
    const key = 'posMode'
    console.log(posMode)
    AsyncStorage.setItem(key, posMode)
    this.setState({posMode})
  }

  handleClickMerchantId() {
    const key = 'merchantId'
    const merchantId = window.prompt('Enter merchant Id', this.state.merchantId)
    console.log(merchantId)
    AsyncStorage.setItem(key, merchantId)
    this.setState({merchantId})
  }

  handleClickCurrency() {
    const key = 'currency'
    const currency = window.prompt('Enter currency', this.state.currency)
    AsyncStorage.setItem(key, currency)
    this.setState({currency})
  }

  handleClickTipsMode() {
    const tipsMode = this.state.tipsMode === 'false' ? 'true' : 'false';
    const key = 'tipsMode';
    AsyncStorage.setItem(key, tipsMode);
    this.setState({tipsMode});
  }

  handleClickTipOnlyMode() {
    const tipOnlyMode = this.state.tipOnlyMode === 'true' ? 'false' : 'true';
    AsyncStorage.setItem('tipOnlyMode', tipOnlyMode);
    this.setState({tipOnlyMode});
  }

  async handleClickFeePassthrough() {
    const feePassthrough = !this.state.feePassthrough;
    this.setState({feePassthrough});

    // Save to AsyncStorage for Main.js
    await AsyncStorage.setItem('feePassthrough', feePassthrough ? 'true' : 'false');

    // Save to backend
    try {
      const apiBase = getApiBaseUrl();
      await fetch(`${apiBase}/stores/${this.state.storeId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fee_passthrough: feePassthrough })
      });
      console.log('Fee passthrough setting saved:', feePassthrough);
    } catch (error) {
      console.error('Failed to save fee passthrough setting:', error);
    }
  }

  async handleClickDiscount(e) {
    const key = 'discount';
    let discount = e.target.value;
    if (!discount) {
      discount = 0;
    } else {
      discount = parseInt(discount);
    }

    // Save to AsyncStorage (local)
    AsyncStorage.setItem(key, discount);
    this.setState({discount});

    // Save to database (for cross-device sync)
    try {
      const apiBase = getApiBaseUrl();
      const response = await fetch(`${apiBase}/stores/${this.state.storeId}/discount`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount })
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Failed to save discount to database:', errorData.error);
      } else {
        console.log('✅ Discount saved to database');
      }
    } catch (error) {
      console.error('Error saving discount to database:', error);
      // Don't block the UI - discount is still saved locally
    }
  }

  handleClickSplash() {
    const splash = this.state.splash === 'default' ? 'custom' : 'default';
    const key = 'splash';
    AsyncStorage.setItem(key, splash);
    this.setState({splash});
  }

  handleWelcomeText(position) {
    const key = position + 'Text';
    const currentText = this.state[key] || '';
    const maxLength = 20;
    const text = window.prompt(
      `Enter ${position} welcome text (max ${maxLength} characters).\nShort messages work best across all screen sizes.`,
      currentText
    );
    if (text !== null) {
      if (text.length > maxLength) {
        alert(`Text is too long! Please limit to ${maxLength} characters.\nYour text was ${text.length} characters.`);
        return;
      }
      AsyncStorage.setItem(key, text);
      this.setState({ [key]: text });

      // Auto-enable custom splash when text is set
      if (text.length > 0 && this.state.splash !== 'custom') {
        AsyncStorage.setItem('splash', 'custom');
        this.setState({ splash: 'custom' });
      }
    }
  }

  handleRetailerPayoutAddress() {
    const currentAddress = this.state.retailerPayoutAddress || '';
    const address = window.prompt(
      'Enter your external Dogecoin wallet address for payouts.\n' +
      'This is where 98% of your funds will be sent when you process payments.',
      currentAddress
    );
    if (address !== null) {
      AsyncStorage.setItem('retailerPayoutAddress', address);
      this.setState({ retailerPayoutAddress: address });
    }
  }

  handleSelectFiat(e) {
    let fiatCurrency = e.target.value;
    const fiatMap = {
      USD: '$',
      GBP: '£',
      CAD: '$',
      EUR: '€',
      JPY: '¥',
      AUD: 'A$',
      CHF: 'Fr',
      CNY: '¥',
      MXN: '$',
      BRL: 'R$',
      INR: '₹',
      SGD: 'S$',
      HKD: 'HK$',
      NZD: 'NZ$',
      SEK: 'kr',
      NOK: 'kr',
      DKK: 'kr',
      PLN: 'zł',
      ZAR: 'R',
      AED: 'د.إ',
      ARS: '$',
      BDT: '৳',
      BHD: 'BD',
      BMD: '$',
      CLP: '$',
      CZK: 'Kč',
      GEL: '₾',
      HUF: 'Ft',
      IDR: 'Rp',
      ILS: '₪',
      KRW: '₩',
      KWD: 'KD',
      LKR: 'Rs',
      MMK: 'K',
      MYR: 'RM',
      NGN: '₦',
      PHP: '₱',
      PKR: 'Rs',
      SAR: 'SR',
      THB: '฿',
      TRY: '₺',
      TWD: 'NT$',
      UAH: '₴',
      VND: '₫',
    }
    let fiatSymbol = fiatMap[fiatCurrency];
    AsyncStorage.setItem('fiatCurrency', fiatCurrency);
    AsyncStorage.setItem('fiatSymbol', fiatSymbol);
    this.setState({fiatCurrency});
    this.setState({fiatSymbol});
  }

  async createWallet(seedPhrase = null, skipBackendSave = false) {
    if (this.state.storeId === 'Unset') {
        window.alert('Please set a store ID first');
        return;
    }

    // Get selected cryptocurrency (defaults to doge if not set)
    const crypto = this.state.selectedCrypto || 'doge';
    const cryptoName = crypto === 'btc' ? 'Bitcoin' : crypto === 'ltc' ? 'Litecoin' : 'Dogecoin';

    console.log(`📦 createWallet called: ${cryptoName}, skipBackendSave=${skipBackendSave}`);

    try {
        let mnemonic;
        if (seedPhrase) {
            // Validate the provided seed phrase
            if (!bip39.validateMnemonic(seedPhrase)) {
                window.alert('Invalid seed phrase');
                return;
            }
            mnemonic = seedPhrase;
            console.log('✅ Using provided seed phrase (import/restore mode)');
        } else {
            // Generate new mnemonic if none provided
            mnemonic = bip39.generateMnemonic();

            // Show the seed phrase and get confirmation
            const confirmMessage = `This is your ${cryptoName} wallet recovery seed. It is CRITICAL that you store this securely:\n\n${mnemonic}\n\nPlease write this down and confirm you have saved it.`;
            if (!window.confirm(confirmMessage)) {
                return;
            }

            // Keep prompting until correct verification or user cancels
            let verified = false;
            while (!verified) {
                const verifyPhrase = window.prompt('Please enter the seed phrase to confirm you have saved it:');
                if (verifyPhrase === null) { // User clicked Cancel
                    return;
                }
                if (verifyPhrase.trim() === mnemonic.trim()) {
                    verified = true;
                } else {
                    if (!window.confirm('Incorrect seed phrase. Would you like to try again?')) {
                        return;
                    }
                }
            }
        }

        // CRITICAL: Store the seed phrase (encrypted) for backup/export functionality
        const seedStorageKey = `walletSeed-${crypto}`;

        try {
            await SecureStorage.setSecureItem(seedStorageKey, mnemonic); // Encrypted!
            console.log(`✅ ${crypto.toUpperCase()} seed phrase stored encrypted`);
        } catch (error) {
            console.error(`Failed to store seed phrase:`, error);
            window.alert(
                `⚠️ Warning: Seed phrase could not be stored!\n\n` +
                `Your wallet will still be created, but you won't be able to export the seed phrase later.\n\n` +
                `PLEASE WRITE DOWN YOUR SEED PHRASE NOW:\n\n${mnemonic}\n\n` +
                `Keep it safe!`
            );
        }

        // Create HD wallet from mnemonic using the appropriate library
        console.log(`Creating ${cryptoName} wallet from mnemonic...`);
        const seed = await bip39.mnemonicToSeed(mnemonic);
        console.log('Generated seed from mnemonic');

        let hdPrivateKey, hdPublicKey;

        if (crypto === 'btc') {
            // Bitcoin wallet creation using BIP84 Native SegWit (browser-compatible)
            console.log('Creating BIP84 Native SegWit Bitcoin wallet...');
            const root = hdkey.fromMasterSeed(seed);

            // BIP84 path: m/84'/0'/0'
            // Using string path for hdkey library (method is .derive(), not .derivePath())
            const bip84Path = "m/84'/0'/0'";
            console.log('Deriving BIP84 path:', bip84Path);

            // Derive to account level: m/84'/0'/0'
            const accountNode = root.derive(bip84Path);

            const wallet = {
                xpriv: accountNode.privateExtendedKey,  // xprv at m/84'/0'/0'
                xpub: accountNode.publicExtendedKey,    // xpub at m/84'/0'/0'
                crypto: crypto,
                derivation_scheme: 'bip84-segwit',
                address_format: 'p2wpkh'
            };

            console.log('BIP84 wallet created:');
            console.log('  Derivation: m/84\'/0\'/0\' (BIP84 Native SegWit)');
            console.log('  Address format: P2WPKH (bc1q...)');
            console.log('  xpub:', wallet.xpub.substring(0, 20) + '...');

            // Save to backend with BIP84 metadata (skip if restoring existing wallet)
            let backendSuccess = skipBackendSave; // If skipping, treat as success
            if (!skipBackendSave) {
                console.log('💾 Saving xpub to backend...');
                const apiBase = getApiBaseUrl();
                const response = await fetch(`${apiBase}/wallets.json`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        store_id: this.state.storeId,
                        crypto: crypto,
                        xpub: wallet.xpub,
                        wallet_name: `${cryptoName} Wallet for ${this.state.storeId}`,
                        derivation_scheme: wallet.derivation_scheme,
                        address_format: wallet.address_format
                    })
                });

                const data = await response.json();
                backendSuccess = (response.ok && data.success);

                if (!backendSuccess) {
                    console.error('❌ Backend save failed:', data);
                    window.alert(`Failed to ${seedPhrase ? 'import' : 'create'} ${cryptoName} wallet: ${data.error || 'Unknown error'}`);
                    return;
                }
                console.log('✅ xpub saved to backend');
            } else {
                console.log('⏭️ Skipping backend save (RESTORE mode)');
            }

            if (backendSuccess) {
                // Save xpriv securely (encrypted) and xpub to storage with crypto prefix
                const storageKeyPriv = `api-key-${crypto}`;
                const storageKeyPub = `api-xpub-${crypto}`;

                // Try to store encrypted, fall back to plaintext if no password available yet
                try {
                    await SecureStorage.setSecureItem(storageKeyPriv, wallet.xpriv); // Encrypted!
                    console.log(`✅ ${crypto.toUpperCase()} private key stored encrypted`);
                } catch (error) {
                    console.warn(`⚠️  Encryption failed, storing ${crypto.toUpperCase()} key in plaintext (password not available)`);
                    await AsyncStorage.setItem(storageKeyPriv, wallet.xpriv); // Fallback to plaintext
                }

                await AsyncStorage.setItem(storageKeyPub, wallet.xpub); // Public key, no encryption needed
                this.setState({ apiKey: wallet.xpriv });

                // Enhanced success message with BIP84 info
                window.alert(
                    `${cryptoName} wallet ${seedPhrase ? 'imported' : 'created'} successfully!\n\n` +
                    `✅ Type: BIP84 Native SegWit\n` +
                    `✅ Addresses: bc1q... (lower fees)\n` +
                    `✅ Compatible with: Sparrow, Electrum, etc.\n\n` +
                    `Derivation path: m/84'/0'/0'\n\n` +
                    `Your wallet's xpub key:\n${wallet.xpub}\n\n` +
                    `⚠️ IMPORTANT: Save your seed phrase securely!\n` +
                    `You can import it into any BIP84-compatible wallet.`
                );
                this.checkWalletStatus();
            }
            return;
        } else if (crypto === 'ltc') {
            // Litecoin wallet creation using BIP84 Native SegWit (browser-compatible)
            console.log('Creating BIP84 Native SegWit Litecoin wallet...');
            const root = hdkey.fromMasterSeed(seed);

            // BIP84 path for Litecoin: m/84'/2'/0' (coin type 2 for Litecoin)
            const bip84Path = "m/84'/2'/0'";
            console.log('Deriving BIP84 path for Litecoin:', bip84Path);

            // Derive to account level: m/84'/2'/0'
            const accountNode = root.derive(bip84Path);

            const wallet = {
                xpriv: accountNode.privateExtendedKey,  // xprv at m/84'/2'/0'
                xpub: accountNode.publicExtendedKey,    // xpub at m/84'/2'/0'
                crypto: crypto,
                derivation_scheme: 'bip84-segwit',
                address_format: 'p2wpkh'
            };

            console.log('BIP84 Litecoin wallet created:');
            console.log('  Derivation: m/84\'/2\'/0\' (BIP84 Native SegWit)');
            console.log('  Address format: P2WPKH (ltc1...)');
            console.log('  xpub:', wallet.xpub.substring(0, 20) + '...');

            // Save to backend with BIP84 metadata (skip if restoring existing wallet)
            let backendSuccess = skipBackendSave; // If skipping, treat as success
            if (!skipBackendSave) {
                console.log('💾 Saving xpub to backend...');
                const apiBase = getApiBaseUrl();
                const response = await fetch(`${apiBase}/wallets.json`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        store_id: this.state.storeId,
                        crypto: crypto,
                        xpub: wallet.xpub,
                        wallet_name: `${cryptoName} Wallet for ${this.state.storeId}`,
                        derivation_scheme: wallet.derivation_scheme,
                        address_format: wallet.address_format
                    })
                });

                const data = await response.json();
                backendSuccess = (response.ok && data.success);

                if (!backendSuccess) {
                    console.error('❌ Backend save failed:', data);
                    window.alert(`Failed to ${seedPhrase ? 'import' : 'create'} ${cryptoName} wallet: ${data.error || 'Unknown error'}`);
                    return;
                }
                console.log('✅ xpub saved to backend');
            } else {
                console.log('⏭️ Skipping backend save (RESTORE mode)');
            }

            if (backendSuccess) {
                // Save xpriv securely (encrypted) and xpub to storage with crypto prefix
                const storageKeyPriv = `api-key-${crypto}`;
                const storageKeyPub = `api-xpub-${crypto}`;

                // Try to store encrypted, fall back to plaintext if no password available yet
                try {
                    await SecureStorage.setSecureItem(storageKeyPriv, wallet.xpriv); // Encrypted!
                    console.log(`✅ ${crypto.toUpperCase()} private key stored encrypted`);
                } catch (error) {
                    console.warn(`⚠️  Encryption failed, storing ${crypto.toUpperCase()} key in plaintext (password not available)`);
                    await AsyncStorage.setItem(storageKeyPriv, wallet.xpriv); // Fallback to plaintext
                }

                await AsyncStorage.setItem(storageKeyPub, wallet.xpub); // Public key, no encryption needed
                this.setState({ apiKey: wallet.xpriv });

                // Enhanced success message with BIP84 info
                window.alert(
                    `${cryptoName} wallet ${seedPhrase ? 'imported' : 'created'} successfully!\n\n` +
                    `✅ Type: BIP84 Native SegWit\n` +
                    `✅ Addresses: ltc1... (lower fees)\n` +
                    `✅ Compatible with: Electrum-LTC, etc.\n\n` +
                    `Derivation path: m/84'/2'/0'\n\n` +
                    `Your wallet's xpub key:\n${wallet.xpub}\n\n` +
                    `⚠️ IMPORTANT: Save your seed phrase securely!\n` +
                    `You can import it into any BIP84-compatible Litecoin wallet.`
                );
                this.checkWalletStatus();
            }
            return;
        } else {
            // Dogecoin wallet creation using BIP44 Standard
            console.log('Creating BIP44 Standard Dogecoin wallet...');

            const HDPrivateKey = bitcoreDoge.HDPrivateKey;
            const network = bitcoreDoge.Networks.livenet;
            const rootKey = HDPrivateKey.fromSeed(seed, network);

            // BIP44 path for Dogecoin: m/44'/3'/0'
            const PURPOSE = 44 + 0x80000000;  // 44' hardened
            const COIN_TYPE = 3 + 0x80000000;  // 3' hardened (Dogecoin)
            const ACCOUNT = 0 + 0x80000000;    // 0' hardened

            console.log('Deriving BIP44 path: m/44\'/3\'/0\'');

            // Derive to account level
            const accountKey = rootKey
                .deriveChild(PURPOSE)
                .deriveChild(COIN_TYPE)
                .deriveChild(ACCOUNT);

            const wallet = {
                xpriv: accountKey.toString(),  // m/44'/3'/0' private key
                xpub: accountKey.hdPublicKey.toString(),  // m/44'/3'/0' public key
                crypto: crypto,
                derivation_scheme: 'bip44-standard',
                address_format: 'p2pkh'
            };

            console.log('BIP44 Dogecoin wallet created:');
            console.log('  Derivation: m/44\'/3\'/0\' (BIP44 Standard)');
            console.log('  Address format: P2PKH (D...)');
            console.log('  Account xpub:', wallet.xpub.substring(0, 20) + '...');

            // Test derive first address to verify
            const externalChain = accountKey.deriveChild(0);  // m/44'/3'/0'/0
            const firstAddressKey = externalChain.deriveChild(0);  // m/44'/3'/0'/0/0
            const firstAddress = firstAddressKey.publicKey.toAddress(network).toString();

            console.log('  First receive address (m/44\'/3\'/0\'/0/0):', firstAddress);

            if (!firstAddress.startsWith('D')) {
                throw new Error(`Invalid Dogecoin address: ${firstAddress}. Expected to start with D`);
            }

            console.log('  ✓ Address verification passed');

            // Save to backend with BIP44 metadata (skip if restoring existing wallet)
            let backendSuccess = skipBackendSave; // If skipping, treat as success
            if (!skipBackendSave) {
                console.log('💾 Saving xpub to backend...');
                const apiBase = getApiBaseUrl();
                const response = await fetch(`${apiBase}/wallets.json`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        store_id: this.state.storeId,
                        crypto: crypto,
                        xpub: wallet.xpub,
                        wallet_name: `${cryptoName} Wallet for ${this.state.storeId}`,
                        derivation_scheme: wallet.derivation_scheme,
                        address_format: wallet.address_format
                    })
                });

                const data = await response.json();
                backendSuccess = (response.ok && data.success);

                if (!backendSuccess) {
                    console.error('❌ Backend save failed:', data);
                    window.alert(`Failed to ${seedPhrase ? 'import' : 'create'} ${cryptoName} wallet: ${data.error || 'Unknown error'}`);
                    return;
                }
                console.log('✅ xpub saved to backend');
            } else {
                console.log('⏭️ Skipping backend save (RESTORE mode)');
            }

            if (backendSuccess) {
                // Save xpriv securely (encrypted) and xpub to storage with crypto prefix
                const storageKeyPriv = `api-key-${crypto}`;
                const storageKeyPub = `api-xpub-${crypto}`;

                // Try to store encrypted, fall back to plaintext if no password available yet
                try {
                    await SecureStorage.setSecureItem(storageKeyPriv, wallet.xpriv); // Encrypted!
                    console.log(`✅ ${crypto.toUpperCase()} private key stored encrypted`);
                } catch (error) {
                    console.warn(`⚠️  Encryption failed, storing ${crypto.toUpperCase()} key in plaintext (password not available)`);
                    await AsyncStorage.setItem(storageKeyPriv, wallet.xpriv); // Fallback to plaintext
                }

                await AsyncStorage.setItem(storageKeyPub, wallet.xpub); // Public key, no encryption needed
                this.setState({ apiKey: wallet.xpriv });

                // Enhanced success message with BIP44 info
                window.alert(
                    `${cryptoName} wallet ${seedPhrase ? 'imported' : 'created'} successfully!\n\n` +
                    `✅ Type: BIP44 Standard\n` +
                    `✅ Addresses: D... (P2PKH)\n` +
                    `✅ Compatible with: Dogecoin Core, Coinomi, Trust Wallet\n\n` +
                    `Derivation path: m/44'/3'/0'\n\n` +
                    `Your wallet's xpub key:\n${wallet.xpub}\n\n` +
                    `⚠️ IMPORTANT: Save your seed phrase securely!\n` +
                    `You can import it into any BIP44-compatible Dogecoin wallet.`
                );
                this.checkWalletStatus();
            }
            return;
        }
    } catch (error) {
        console.error(`Error with ${cryptoName} wallet:`, error);
        window.alert(`Failed to ${seedPhrase ? 'import' : 'create'} ${cryptoName} wallet. Please try again.\n\nError: ${error.message}`);
    }
  }

  /**
   * Handle cryptocurrency selection for import
   * Note: We allow import even if wallet exists locally, because the xpub
   * comparison in handleImportWallet() will detect fraud vs legitimate restore.
   */
  async handleImportSelectCrypto(crypto) {
    // Check if wallet already exists for this crypto
    const seedKey = `walletSeed-${crypto}`;
    const hasWallet = await SecureStorage.hasSecureItem(seedKey);

    if (hasWallet) {
      const cryptoName = crypto === 'btc' ? 'Bitcoin' : crypto === 'ltc' ? 'Litecoin' : 'Dogecoin';

      // Warn user but allow them to proceed (for legitimate restore scenarios)
      const proceed = window.confirm(
        `⚠️ ${cryptoName} Wallet Already Exists\n\n` +
        `This device already has a ${cryptoName} wallet configured.\n\n` +
        `If you're restoring your wallet from the same seed phrase, click OK to proceed.\n\n` +
        `⚠️ WARNING: If you enter a DIFFERENT seed phrase, the import will be blocked for security.\n\n` +
        `Proceed with import?`
      );

      if (!proceed) {
        this.setState({ showImportModal: false });
        return;
      }
    }

    // Proceed to seed phrase entry (xpub comparison will handle security)
    this.setState({ importCrypto: crypto });
  }

  /**
   * Handle wallet import from seed phrase with smart detection
   * Validates seed phrase, verifies password, and imports wallet
   * Supports three scenarios:
   * 1. NEW WALLET: No wallet exists → save to backend
   * 2. RESTORE: Wallet exists with matching xpub → save locally only
   * 3. FRAUD: Wallet exists with different xpub → block import
   */
  async handleImportWallet() {
    this.setState({ importing: true });

    try {
      const { importCrypto, importSeedPhrase, storeId } = this.state;
      const cryptoName = importCrypto === 'btc' ? 'Bitcoin' : importCrypto === 'ltc' ? 'Litecoin' : 'Dogecoin';

      console.log(`🔐 Starting wallet import for ${cryptoName}...`);

      // Step 1: Validate seed phrase
      const seedPhrase = importSeedPhrase.trim().toLowerCase();
      const words = seedPhrase.split(/\s+/);

      if (words.length !== 12) {
        window.alert(
          `Invalid Seed Phrase\n\n` +
          `Seed phrase must be exactly 12 words.\n` +
          `You entered ${words.length} word${words.length !== 1 ? 's' : ''}.`
        );
        this.setState({ importing: false });
        return;
      }

      if (!bip39.validateMnemonic(seedPhrase)) {
        window.alert(
          `Invalid Seed Phrase\n\n` +
          `The seed phrase contains invalid words or checksum is incorrect.\n\n` +
          `Please check for typos and try again.`
        );
        this.setState({ importing: false });
        return;
      }

      console.log('✅ Seed phrase validated');

      // Step 2: Derive xpub from seed phrase to compare with backend
      console.log('📊 Deriving xpub from seed phrase...');
      const seed = await bip39.mnemonicToSeed(seedPhrase);
      let derivedXpub;

      if (importCrypto === 'btc') {
        const root = hdkey.fromMasterSeed(seed);
        const accountNode = root.derive("m/84'/0'/0'");
        derivedXpub = accountNode.publicExtendedKey;
      } else if (importCrypto === 'ltc') {
        const root = hdkey.fromMasterSeed(seed);
        const accountNode = root.derive("m/84'/2'/0'");
        derivedXpub = accountNode.publicExtendedKey;
      } else { // doge
        const HDPrivateKey = bitcoreDoge.HDPrivateKey;
        const network = bitcoreDoge.Networks.livenet;
        const rootKey = HDPrivateKey.fromSeed(seed, network);
        const PURPOSE = 44 + 0x80000000;
        const COIN_TYPE = 3 + 0x80000000;
        const ACCOUNT = 0 + 0x80000000;
        const accountKey = rootKey.deriveChild(PURPOSE).deriveChild(COIN_TYPE).deriveChild(ACCOUNT);
        derivedXpub = accountKey.xpubkey;
      }

      console.log(`✅ Derived xpub: ${derivedXpub.substring(0, 20)}...`);

      // Step 3: Check backend for existing wallet
      console.log('🔍 Checking backend for existing wallet...');
      const apiBase = getApiBaseUrl();

      let existingWallet = null;
      try {
        const checkResponse = await fetch(`${apiBase}/wallets/check/${storeId}/${importCrypto}`);
        if (checkResponse.ok) {
          existingWallet = await checkResponse.json();
          console.log('   Found existing wallet in backend');
        } else if (checkResponse.status === 404) {
          console.log('   No existing wallet found (NEW WALLET scenario)');
        } else {
          throw new Error(`Backend returned ${checkResponse.status}`);
        }
      } catch (error) {
        console.error('   Error checking backend:', error.message);
        window.alert(
          `Network Error\n\n` +
          `Could not verify wallet status with backend.\n` +
          `Please check your connection and try again.`
        );
        this.setState({ importing: false });
        return;
      }

      // Step 4: Compare xpubs and determine scenario
      let importMode;
      if (!existingWallet || !existingWallet.exists) {
        // SCENARIO 1: No wallet exists → NEW WALLET mode
        importMode = 'NEW_WALLET';
        console.log('✅ SCENARIO 1: NEW WALLET - will save to backend');
      } else if (existingWallet.xpub === derivedXpub) {
        // SCENARIO 2: Wallet exists with matching xpub → RESTORE mode
        importMode = 'RESTORE';
        console.log('✅ SCENARIO 2: RESTORE - xpub matches, will save locally only');
      } else {
        // SCENARIO 3: Wallet exists with different xpub → FRAUD attempt
        console.error('🚨 SCENARIO 3: FRAUD DETECTED - xpub mismatch!');
        console.error(`   Backend xpub: ${existingWallet.xpub.substring(0, 20)}...`);
        console.error(`   Derived xpub: ${derivedXpub.substring(0, 20)}...`);

        window.alert(
          `⚠️ WALLET MISMATCH DETECTED\n\n` +
          `This seed phrase generates a DIFFERENT ${cryptoName} wallet than the one registered for this store.\n\n` +
          `This could indicate:\n` +
          `• You entered the wrong seed phrase\n` +
          `• This seed phrase belongs to a different store\n` +
          `• Unauthorized wallet replacement attempt\n\n` +
          `Import blocked for security.\n\n` +
          `If you believe this is an error, please contact support.`
        );

        this.setState({ importing: false });
        return;
      }

      // Step 5: Require password verification
      const password = window.prompt(
        `Enter your store password to ${importMode === 'RESTORE' ? 'restore' : 'import'} ${cryptoName} wallet:`
      );

      if (!password) {
        this.setState({ importing: false });
        return;
      }

      const storedPassword = await AsyncStorage.getItem('storePassword');
      if (password !== storedPassword) {
        window.alert('Incorrect password. Import cancelled.');
        this.setState({ importing: false });
        return;
      }

      console.log('✅ Password verified');

      // Step 6: Close modal and import wallet
      this.setState({
        showImportModal: false,
        importCrypto: null,
        importSeedPhrase: '',
        importing: false
      });

      // Set selected crypto
      await new Promise(resolve => {
        this.setState({ selectedCrypto: importCrypto }, resolve);
      });

      // Import wallet (with flag to skip backend POST if restoring)
      const skipBackendSave = (importMode === 'RESTORE');
      await this.createWallet(seedPhrase, skipBackendSave);

      // Step 7: Sync balance from blockchain
      if (importMode === 'RESTORE') {
        console.log('🔄 Syncing balance from blockchain...');
        try {
          const syncResponse = await fetch(`${apiBase}/wallets/sync/${storeId}/${importCrypto}`, {
            method: 'POST'
          });
          const syncData = await syncResponse.json();

          if (syncData.success) {
            console.log(`✅ Balance synced: ${syncData.balance} ${cryptoName.toUpperCase()}`);
          } else {
            console.warn('⚠️ Balance sync warning:', syncData.message);
          }
        } catch (error) {
          console.error('❌ Balance sync failed:', error.message);
          // Don't block import if sync fails - balance will update on next payment
        }
      }

      // Step 8: Refresh settlement data to display correct balance
      console.log('🔄 Refreshing balance display for imported wallet...');
      await this.fetchSettlementData();
      await this.fetchPayments();

    } catch (error) {
      console.error('❌ Import error:', error);
      window.alert('Import failed. Please try again.');
      this.setState({ importing: false });
    }
  }

  async checkWalletStatus() {
    const storeId = await AsyncStorage.getItem('store-id');
    console.log('config storeId: ', storeId)

    console.log('checking wallet status for storeId: ', storeId)
    if (!storeId) {
        console.log('no storeId')
        this.setState({
            hasWallet: false,
            walletLoading: false,
            btcWallet: null,
            ltcWallet: null,
            dogeWallet: null
        });
        return;
    }

    try {
        const apiBase = getApiBaseUrl();

        // Check SecureStorage and AsyncStorage for which wallets were actually created locally
        const btcKey = await SecureStorage.hasSecureItem('api-key-btc') || await AsyncStorage.getItem('api-key-btc');
        const ltcKey = await SecureStorage.hasSecureItem('api-key-ltc') || await AsyncStorage.getItem('api-key-ltc');
        const dogeKey = await SecureStorage.hasSecureItem('api-key-doge') || await AsyncStorage.getItem('api-key-doge');

        // Get locally stored xpub keys
        const btcXpub = await AsyncStorage.getItem('api-xpub-btc');
        const ltcXpub = await AsyncStorage.getItem('api-xpub-ltc');
        const dogeXpub = await AsyncStorage.getItem('api-xpub-doge');

        console.log('Local storage keys:', {
            hasBtc: Boolean(btcKey),
            hasLtc: Boolean(ltcKey),
            hasDoge: Boolean(dogeKey)
        });

        // Build wallet objects using locally stored xpub keys
        let btcWallet = null;
        let ltcWallet = null;
        let dogeWallet = null;

        if (btcKey && btcXpub) {
            btcWallet = {
                hd_public_key: btcXpub,
                owner_name: storeId,
                crypto: 'btc'
            };
        }

        if (ltcKey && ltcXpub) {
            ltcWallet = {
                hd_public_key: ltcXpub,
                owner_name: storeId,
                crypto: 'ltc'
            };
        }

        if (dogeKey && dogeXpub) {
            dogeWallet = {
                hd_public_key: dogeXpub,
                owner_name: storeId,
                crypto: 'doge'
            };
        }

        // Auto-select first available crypto if current selection doesn't have wallet
        let selectedCrypto = this.state.selectedCrypto || 'doge';
        let hasWallet = false;

        // Check if currently selected crypto has a wallet
        if (selectedCrypto === 'btc') hasWallet = Boolean(btcWallet);
        else if (selectedCrypto === 'ltc') hasWallet = Boolean(ltcWallet);
        else hasWallet = Boolean(dogeWallet);

        // If current crypto doesn't have wallet, auto-select first available
        if (!hasWallet) {
            if (dogeWallet) {
                selectedCrypto = 'doge';
                hasWallet = true;
            } else if (btcWallet) {
                selectedCrypto = 'btc';
                hasWallet = true;
            } else if (ltcWallet) {
                selectedCrypto = 'ltc';
                hasWallet = true;
            }
        }

        this.setState({
            hasWallet,
            btcWallet,
            ltcWallet,
            dogeWallet,
            selectedCrypto,  // Update selected crypto to first available
            walletLoading: false
        });

        console.log('Processed wallet status:', { btcWallet, ltcWallet, dogeWallet, selectedCrypto });
    } catch (error) {
        console.error('Error checking wallet status:', error);

        this.setState({
            hasWallet: false,
            btcWallet: null,
            ltcWallet: null,
            dogeWallet: null,
            walletLoading: false
        });
    }
  }

  tips() {
    if (!this.state.utxos || !this.state.tips) {
        return [];
    }

    let tipAmounts = [];
    for (let utxo of this.state.utxos) {
        // Derive the public address from the utxo's keyDepth
        // (This would require access to the HD wallet, which we don't have here)
        // Instead, we'll use the tips data directly from the settlement payload
        const addr = utxo.address;
        const tip = this.state.tips[addr] || 0;
        if (tip > 0) {
            tipAmounts.push(tip);
        }
    }
    return tipAmounts;
  }

  map(prop) {
    return this.state.payments.map((item) => (item[prop] ? item[prop] : 0))
  }

  sum(arry) {
    return arry.reduce((partialSum, a) => partialSum + a, 0)
  }

  collected() {
    return this.state.totalSatoshis / 100_000_000;
  }

  // Sales amount (excluding tips)
  salesAmount() {
    return this.collected() - (this.state.totalTipsAvailable || 0);
  }

  serviceFee() {
    // CRITICAL: Fee should only apply to SALES, not tips
    const salesOnly = this.salesAmount();
    if (salesOnly > 0) {
      const feePercentage = (this.state.dijittoFeePercentage || 2.50) / 100;
      return salesOnly * feePercentage;
    } else {
      return 0;
    }
  }

  payoutAmount() {
    // Retailer gets: sales - fee (tips go to employees, not retailer)
    return this.salesAmount() - this.serviceFee();
  }

  hasPayoutAddressSet(crypto) {
    const cryptoLower = crypto.toLowerCase();
    let address;

    if (cryptoLower === 'doge') {
      address = this.state.payoutAddressDoge;
    } else if (cryptoLower === 'btc') {
      address = this.state.payoutAddressBtc;
    } else if (cryptoLower === 'ltc') {
      address = this.state.payoutAddressLtc;
    }

    return address && address.trim().length > 0;
  }

  async fetchSettlementData() {
    if (this.state.storeId === 'Unset') {
        this.setState({
            utxos: [],
            tips: {},
            totalSatoshis: 0
        });
        return;
    }

    try {
        // Build URL with query parameter including crypto
        const apiBase = getApiBaseUrl();
        const url = new URL(`${apiBase}/utxos?store_id=${this.state.storeId}&crypto=${this.state.selectedCrypto}`);
        // url.searchParams.append('store_id', this.state.storeId);
        
        let response;
        try {
          response = await fetch(url.toString(), {
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/json'
            }
          });
        } catch (error) {
          console.error('Error fetching utxos:', error);
          this.setState({
            utxos: [],
            tips: {},
            totalSatoshis: 0
          });
          return;
        }

        console.log('got utxos response')
        console.log('response: ', response)
        console.log('response.ok: ', response.ok)

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const payload = await response.json();

        let totalSatoshis = 0;
        if (payload.utxos) {
            totalSatoshis = payload.utxos.reduce((sum, utxo) => sum + utxo.satoshis, 0);
        }

        // Tip pool is already tracked separately in the database (payments.tip_amount)
        // It's already in DOGE/BTC/LTC from when the payment was created
        const totalTipsAvailable = payload.total_tips || 0;
        const walletBalance = totalSatoshis / 100000000; // Convert satoshis to crypto unit

        console.log(`💰 Wallet balance: ${walletBalance.toFixed(8)} ${this.state.selectedCrypto.toUpperCase()}`);
        console.log(`💰 Tip pool available for employees: ${totalTipsAvailable.toFixed(8)} ${this.state.selectedCrypto.toUpperCase()}`);

        this.setState({
            utxos: payload.utxos || [],
            tips: payload.tips || {},
            totalSatoshis: totalSatoshis,
            totalTipsAvailable: totalTipsAvailable
        });
    } catch (error) {
        console.error('Failed to fetch settlement data:', error);
        this.setState({
            utxos: [],
            tips: {},
            totalSatoshis: 0
        });
    }
  }

  async fetchAllBalances() {
    // Fetch balances for all cryptocurrencies for swap modal
    if (this.state.storeId === 'Unset') {
      this.setState({
        btcBalance: 0,
        ltcBalance: 0,
        dogeBalance: 0
      });
      return;
    }

    try {
      const apiBase = getApiBaseUrl();
      const cryptos = ['btc', 'ltc', 'doge'];
      const balances = {};

      // Fetch balances for all cryptos in parallel
      await Promise.all(cryptos.map(async (crypto) => {
        try {
          const url = `${apiBase}/utxos?store_id=${this.state.storeId}&crypto=${crypto}`;
          const response = await fetch(url, {
            headers: {
              'Accept': '*/*',
              'Content-Type': 'application/json'
            }
          });

          if (response.ok) {
            const payload = await response.json();
            const totalSatoshis = payload.utxos ? payload.utxos.reduce((sum, utxo) => sum + utxo.satoshis, 0) : 0;
            balances[`${crypto}Balance`] = totalSatoshis / 100000000; // Convert to crypto unit
          } else {
            balances[`${crypto}Balance`] = 0;
          }
        } catch (error) {
          console.error(`Error fetching ${crypto.toUpperCase()} balance:`, error);
          balances[`${crypto}Balance`] = 0;
        }
      }));

      console.log('All balances fetched:', balances);
      this.setState(balances);
    } catch (error) {
      console.error('Failed to fetch all balances:', error);
      this.setState({
        btcBalance: 0,
        ltcBalance: 0,
        dogeBalance: 0
      });
    }
  }

  /**
   * Fetch retailer rewards dashboard data
   */
  async fetchRetailerRewards() {
    if (!this.state.storeId || this.state.storeId === 'Unset') {
      return;
    }

    this.setState({ loadingRetailerRewards: true, retailerRewardsError: null });

    try {
      const apiBase = getApiBaseUrl();
      const response = await fetch(`${apiBase}/api/retailer-rewards/dashboard?store_id=${this.state.storeId}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch rewards');
      }

      const data = await response.json();
      this.setState({
        retailerRewards: data,
        loadingRetailerRewards: false
      });
    } catch (error) {
      console.error('Error fetching retailer rewards:', error);
      this.setState({
        retailerRewardsError: error.message,
        loadingRetailerRewards: false
      });
    }
  }

  /**
   * Format event type for display
   */
  formatEventType(eventType) {
    const labels = {
      'payment_received': 'Payment Received',
      'daily_active': 'Daily Active Bonus',
      'new_customer': 'New Customer',
      'volume_milestone_100': '100 Payments Milestone',
      'volume_milestone_500': '500 Payments Milestone',
      'volume_milestone_1000': '1000 Payments Milestone'
    };
    return labels[eventType] || eventType;
  }

  /**
   * Fetch personal wallets for retailer
   */
  async fetchPersonalWallets() {
    if (!this.state.storeId || this.state.storeId === 'Unset') {
      return;
    }

    this.setState({ loadingWallets: true });

    try {
      const apiBase = getApiBaseUrl();
      const response = await fetch(`${apiBase}/api/retailer-rewards/wallets?store_id=${this.state.storeId}`);
      const data = await response.json();

      this.setState({
        personalWallets: data.wallets || [],
        customerRewards: data.customerAccount,
        loadingWallets: false
      });
    } catch (error) {
      console.error('Error fetching personal wallets:', error);
      this.setState({ loadingWallets: false });
    }
  }

  /**
   * Add a personal wallet
   */
  async addPersonalWallet() {
    const { newWalletAddress, newWalletCrypto, newWalletLabel, storeId } = this.state;

    if (!newWalletAddress.trim()) {
      alert('Please enter a wallet address');
      return;
    }

    this.setState({ addingWallet: true });

    try {
      const apiBase = getApiBaseUrl();
      const response = await fetch(`${apiBase}/api/retailer-rewards/wallets?store_id=${storeId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          address: newWalletAddress.trim(),
          crypto: newWalletCrypto,
          label: newWalletLabel.trim() || null
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to add wallet');
      }

      // Clear form and refresh wallets
      this.setState({
        newWalletAddress: '',
        newWalletLabel: '',
        addingWallet: false
      });

      // Refresh wallet list
      this.fetchPersonalWallets();

    } catch (error) {
      console.error('Error adding wallet:', error);
      alert(error.message || 'Failed to add wallet');
      this.setState({ addingWallet: false });
    }
  }

  /**
   * Remove a personal wallet
   */
  async removePersonalWallet(walletId) {
    if (!window.confirm('Remove this wallet address?')) {
      return;
    }

    try {
      const apiBase = getApiBaseUrl();
      const response = await fetch(`${apiBase}/api/retailer-rewards/wallets/${walletId}?store_id=${this.state.storeId}`, {
        method: 'DELETE'
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Failed to remove wallet');
      }

      // Refresh wallet list
      this.fetchPersonalWallets();

    } catch (error) {
      console.error('Error removing wallet:', error);
      alert(error.message || 'Failed to remove wallet');
    }
  }

  async fetchPayments() {
    if (this.state.storeId === 'Unset') {
        this.setState({ payments: [] });
        return;
    }

    try {
        const apiBase = getApiBaseUrl();
        const url = new URL(`${apiBase}/payments?store_id=${this.state.storeId}&crypto=${this.state.selectedCrypto}`);

        const response = await fetch(url.toString(), {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const payload = await response.json();
        console.log('Payment history:', payload);

        this.setState({
            payments: payload.payments || []
        });
    } catch (error) {
        console.error('Failed to fetch payment history:', error);
        this.setState({ payments: [] });
    }
  }

  handleCryptoChange(event) {
    this.setState({ selectedCrypto: event.target.value }, () => {
      this.fetchSettlementData();
      this.fetchPayments();
    });
  }

  // Employee Tipping Functions
  async fetchEligibleEmployees() {
    const { selectedCrypto, storeId } = this.state;
    const apiBase = getApiBaseUrl();

    this.setState({ loadingEmployees: true });

    try {
      const crypto = selectedCrypto.toLowerCase(); // 'doge', 'btc', or 'ltc'
      const response = await fetch(`${apiBase}/employees/store/${storeId}/for-payout?crypto=${crypto}`);
      const data = await response.json();

      if (data.success) {
        this.setState({
          eligibleEmployees: data.employees,
          loadingEmployees: false
        });
      } else {
        console.error('Failed to fetch employees:', data.error);
        this.setState({
          eligibleEmployees: [],
          loadingEmployees: false
        });
      }
    } catch (error) {
      console.error('Error fetching employees:', error);
      this.setState({
        eligibleEmployees: [],
        loadingEmployees: false
      });
    }
  }

  handleTipConfirm(employeeTips) {
    console.log('Tips confirmed:', employeeTips);
    this.setState({
      showTipModal: false,
      employeeTips: employeeTips  // Store for use in both calculate and broadcast
    }, () => {
      // Proceed directly to payout confirmation (skip redundant Z Report screen)
      this.handleSignAndSendTransaction();
    });
  }

  handleTipSkip() {
    console.log('Tips skipped');
    this.setState({
      showTipModal: false,
      employeeTips: []  // Empty array means no tips
    }, () => {
      // Proceed directly to payout confirmation (skip redundant Z Report screen)
      this.handleSignAndSendTransaction();
    });
  }

  async fetchStoreData() {
    if (this.state.storeId === 'Unset') {
        return;
    }

    try {
        const apiBase = getApiBaseUrl();
        const url = `${apiBase}/stores/${this.state.storeId}`;

        const response = await fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const payload = await response.json();
        console.log('Store data:', payload);

        if (payload.success && payload.store) {
            // Update store name from database (fixes stale AsyncStorage issue)
            const storeName = payload.store.store_name;

            this.setState({
                storeName: storeName || '',
                payoutAddressDoge: payload.store.payout_address_doge || '',
                payoutAddressBtc: payload.store.payout_address_btc || '',
                payoutAddressLtc: payload.store.payout_address_ltc || '',
                dijittoFeePercentage: payload.store.dijitto_fee_percentage || 2.50,
                feePassthrough: payload.store.fee_passthrough || false
            });

            // Sync fee passthrough to AsyncStorage for Main.js to use
            await AsyncStorage.setItem('feePassthrough', payload.store.fee_passthrough ? 'true' : 'false');

            // Update AsyncStorage with correct store name
            if (storeName) {
                await AsyncStorage.setItem('store-name', storeName);
            }
        }
    } catch (error) {
        console.error('Failed to fetch store data:', error);
    }
  }

  async checkSuspensionStatus() {
    if (!this.state.storeId || this.state.storeId === 'Unset') {
      return;
    }

    try {
      const apiBase = getApiBaseUrl();
      const response = await fetch(`${apiBase}/stores/${this.state.storeId}/suspension-status`);

      if (!response.ok) {
        console.error('Failed to check suspension status:', response.status);
        return;
      }

      const data = await response.json();

      if (data.is_suspended) {
        this.setState({
          isSuspended: true,
          suspensionReason: data.suspension_reason,
          suspendedAt: data.suspended_at
        });
      }
    } catch (error) {
      console.error('Error checking suspension status:', error);
    }
  }

  async handleSavePayoutAddresses() {
    const password = window.prompt('Enter admin password to update payout addresses:');

    if (!password) {
        alert('Password required to update payout addresses');
        return;
    }

    // Verify store password
    const storedPassword = await AsyncStorage.getItem('storePassword');
    if (!storedPassword) {
        alert('Store password not found. Please log out and log in again with your store password.');
        return;
    }

    if (password !== storedPassword) {
        alert('Incorrect password');
        return;
    }

    try {
        const apiBase = getApiBaseUrl();
        const url = `${apiBase}/stores/${this.state.storeId}`;

        const response = await fetch(url, {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                payout_address_doge: this.state.payoutAddressDoge,
                payout_address_btc: this.state.payoutAddressBtc,
                payout_address_ltc: this.state.payoutAddressLtc
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const payload = await response.json();
        console.log('Payout addresses updated:', payload);
        alert('Payout addresses updated successfully!');
        this.setState({ showPayoutSettings: false });
    } catch (error) {
        console.error('Failed to update payout addresses:', error);
        alert('Failed to update payout addresses: ' + error.message);
    }
  }

  handleAddTipAddress = () => {
    const address = this.state.newTipAddress.trim();
    if (address && !this.state.tipsPool.includes(address)) {
        this.setState(prevState => ({
            tipsPool: [...prevState.tipsPool, address],
            newTipAddress: '' // Clear input after adding
        }));
    }
  }

  handleRemoveTipAddress = (addressToRemove) => {
    this.setState(prevState => ({
        tipsPool: prevState.tipsPool.filter(address => address !== addressToRemove)
    }));
  }

  renderTipsPoolManager() {
    if (!this.sum(this.tips())) {
        return null;
    }

    return (
        <div className="tips-pool-manager">
            <h4>Tips Pool Management</h4>
            <p>Total Tips: Ɖ{this.sum(this.tips()).toFixed(8)}</p>
            
            <div className="tips-input-container">
                <input
                    type="text"
                    value={this.state.newTipAddress}
                    onChange={(e) => this.setState({ newTipAddress: e.target.value })}
                    placeholder="Enter Dogecoin address"
                    className="tips-input"
                />
                <button 
                    onClick={this.handleAddTipAddress}
                    className="add-button"
                    disabled={!this.state.newTipAddress.trim()}
                >
                    <span>+</span>
                </button>
            </div>

            <div className="tips-list">
                {this.state.tipsPool.length === 0 ? (
                    <p className="no-addresses">No addresses added yet</p>
                ) : (
                    this.state.tipsPool.map((address, index) => (
                        <div key={index} className="address-item">
                            <span className="address-text">{address}</span>
                            <button 
                                onClick={() => this.handleRemoveTipAddress(address)}
                                className="remove-button"
                            >
                                <span>−</span>
                            </button>
                        </div>
                    ))
                )}
            </div>

            {this.state.tipsPool.length > 0 && (
                <p className="tips-distribution">
                    Each address will receive: Ɖ{(this.sum(this.tips()) / this.state.tipsPool.length).toFixed(8)}
                </p>
            )}

            <style jsx>{`
                .tips-pool-manager {
                    margin-top: 15px;
                    padding: 15px;
                    background: #f8f9fa;
                    border-radius: 4px;
                }
                .tips-input-container {
                    display: flex;
                    gap: 10px;
                    margin-bottom: 15px;
                }
                .tips-input {
                    flex: 1;
                    padding: 8px;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    font-size: 14px;
                }
                .add-button, .remove-button {
                    width: 36px;
                    height: 36px;
                    border-radius: 18px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 20px;
                    cursor: pointer;
                    border: none;
                    padding: 0;
                }
                .add-button {
                    background-color: #28a745;
                    color: white;
                }
                .add-button:disabled {
                    background-color: #6c757d;
                    cursor: not-allowed;
                }
                .remove-button {
                    background-color: #dc3545;
                    color: white;
                }
                .tips-list {
                    max-height: 200px;
                    overflow-y: auto;
                    margin-bottom: 15px;
                }
                .address-item {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 8px;
                    background: white;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    margin-bottom: 5px;
                }
                .address-text {
                    flex: 1;
                    font-family: monospace;
                    font-size: 14px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .no-addresses {
                    color: #6c757d;
                    text-align: center;
                    font-style: italic;
                }
                .tips-distribution {
                    margin-top: 10px;
                    font-weight: bold;
                    color: #28a745;
                }
            `}</style>
        </div>
    );
  }

	render() {
		if (this.state.showPayoutView) {
			return (
				<Container style={{paddingBottom: 'max(30px, env(safe-area-inset-bottom, 0px))'}}>
					<Row>
						<Col>
							<div className="admin-header">
								<h1>Payout</h1>
								<button 
									className="home-button" 
									onClick={() => window.location = '/'}
								>
									Home
								</button>
							</div>
							{this.renderPayoutView()}
						</Col>
					</Row>
					<style jsx>{`
						.payout-view {
							padding: 20px;
							background: white;
							border-radius: 5px;
							border: 1px solid #ddd;
						}
						.utxo-summary {
							margin: 20px 0;
							padding: 15px;
							background: #f8f9fa;
							border-radius: 4px;
						}
						.summary-row {
							display: flex;
							justify-content: space-between;
							padding: 10px 0;
							border-bottom: 1px solid #dee2e6;
						}
						.summary-row.total {
							font-weight: bold;
							border-bottom: none;
							margin-top: 10px;
							padding-top: 20px;
							border-top: 2px solid #dee2e6;
						}
						.payout-actions {
							margin-top: 20px;
							display: flex;
							gap: 10px;
							justify-content: center;
						}
						.secondary-button {
							background-color: #6c757d;
							border-color: #6c757d;
						}
						.secondary-button:hover {
							background-color: #5a6268;
						}
					`}</style>

          <style jsx>{`
            .admin-section {
              margin: 20px 0;
              padding: 20px;
              border: 1px solid #ddd;
              border-radius: 5px;
            }
            .success-text {
              color: #28a745;
              font-weight: bold;
            }
            .warning-text {
              color: #ffc107;
              font-weight: bold;
            }
            .setting-row {
              margin: 10px 0;
              display: flex;
              align-items: center;
            }
            .radio-group {
              display: flex;
              align-items: center;
              gap: 10px;
            }
            .separator {
              color: #666;
            }
            label {
              margin-right: 10px;
              font-weight: bold;
            }
            select {
              padding: 5px;
              border-radius: 4px;
              border: 1px solid #ddd;
            }
            .z-report {
              background: white;
              padding: 20px;
              border-radius: 5px;
            }
            .report-header {
              display: flex;
              justify-content: space-between;
              margin-bottom: 10px;
            }
            .report-row {
              display: flex;
              justify-content: space-between;
              margin: 5px 0;
            }
            .report-actions {
              margin-top: 20px;
              text-align: center;
            }
            .paid-status {
              margin-top: 10px;
              text-align: center;
              background: #28a745;
              color: white;
              padding: 5px;
              border-radius: 4px;
            }
            button {
              padding: 8px 16px;
              margin: 5px;
              border: 1px solid #007bff;
              background-color: #007bff;
              color: white;
              border-radius: 4px;
              cursor: pointer;
            }
            button:hover {
              background-color: #0056b3;
            }
            .nav-bar {
              background-color: black;
              padding: 10px;
              margin-bottom: 20px;
            }
            .home-button {
              background-color: transparent;
              color: white;
              border: 1px solid white;
              border-radius: 4px;
              padding: 8px 16px;
              cursor: pointer;
              width: 100px;
            }
            .home-button:hover {
              background-color: rgba(255, 255, 255, 0.1);
            }
            .admin-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 20px;
              padding: 10px 0;
              padding-top: calc(10px + env(safe-area-inset-top, 24px));
              padding-top: calc(10px + max(env(safe-area-inset-top, 0px), 24px));
            }
            .home-button {
              padding: 8px 16px;
              background-color: #007bff;
              color: white;
              border: 1px solid #0056b3;
              border-radius: 4px;
              cursor: pointer;
              font-size: 16px;
              transition: background-color 0.2s;
            }
            .home-button:hover {
              background-color: #0056b3;
            }
            .loading-state {
              text-align: center;
              padding: 20px;
            }
            .loading-spinner {
              border: 4px solid #f3f3f3;
              border-top: 4px solid #007bff;
              border-radius: 50%;
              width: 40px;
              height: 40px;
              animation: spin 1s linear infinite;
              margin: 0 auto 15px;
            }
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>

				</Container>
			);
		}

		return (
			<Container style={{paddingBottom: 'max(30px, env(safe-area-inset-bottom, 0px))'}}>
				<Row>
					<Col>
						<div className="admin-header">
							<h1>Admin</h1>
							<button 
								className="home-button" 
								onClick={() => window.location = '/'}
							>
								Home
							</button>
						</div>

						{this.state.isSuspended && (
							<div className="suspension-banner">
								<h3 style={{color: '#721c24', marginTop: 0}}>⛔ Account Suspended</h3>
								<p><strong>Your account has been suspended due to unauthorized wallet activity.</strong></p>
								<p>
									You cannot accept new payments while suspended, but you can still withdraw
									your existing balance via Z-out.
								</p>
								<p style={{marginBottom: 0}}>
									To request reactivation, email <strong>support@dijitto.io</strong> with subject
									"Store Reactivation Request - {this.state.storeId}"
								</p>
							</div>
						)}

						{/* ========== ACCORDION NAVIGATION ========== */}
						<Accordion defaultActiveKey={[]} alwaysOpen>

						{/* ========== GROUP 1: STORE SETUP ========== */}
						<Accordion.Item eventKey="0">
							<Accordion.Header>
								<span style={{ fontSize: '18px', fontWeight: 'bold' }}>⚙️ Store Setup</span>
							</Accordion.Header>
							<Accordion.Body>

						<div className="admin-section">
							<h3>Store Configuration</h3>
						{/* Manual Store ID entry removed - now uses token-based activation */}
						{/* <button onClick={this.handleClickStoreId}>Set Store ID ({this.state.storeId})</button> */}
						<div style={{marginTop: '10px', fontSize: '14px', color: '#666'}}>
							Store ID: <strong>{this.state.storeId}</strong>
						</div>
							{this.state.storeName && (
								<div style={{marginTop: '10px', fontSize: '14px', color: '#666'}}>
									Store Name: <strong>{this.state.storeName}</strong>
								</div>
							)}
						</div>

						<div className="admin-section">
							<h3>Cryptocurrency Selection</h3>
							<div className="setting-row" style={{
								display: 'flex',
								flexDirection: this.state.isSmallScreen ? 'column' : 'row',
								alignItems: this.state.isSmallScreen ? 'flex-start' : 'center',
								gap: '10px'
							}}>
								<label>Select Cryptocurrency: </label>
								<select
									value={this.state.selectedCrypto}
									onChange={this.handleCryptoChange}
									className="crypto-dropdown"
									style={{
										width: this.state.isSmallScreen ? '100%' : 'auto',
										maxWidth: '100%',
										padding: '8px 12px',
										fontSize: '16px',
										borderRadius: '4px',
										border: '1px solid #ccc'
									}}
								>
									{/* Always show all three cryptos - this dropdown is for selecting which wallet to work with */}
									<option value="btc">BTC - Bitcoin</option>
									<option value="ltc">LTC - Litecoin</option>
									<option value="doge">DOGE - Dogecoin</option>
								</select>
							</div>
							<div className={`crypto-badge crypto-badge-${this.state.selectedCrypto}`}>
								<span className="crypto-badge-icon">
									{this.state.selectedCrypto === 'btc' && '₿'}
									{this.state.selectedCrypto === 'ltc' && 'Ł'}
									{this.state.selectedCrypto === 'doge' && 'Ɖ'}
								</span>
								<span className="crypto-badge-text">
									{this.state.selectedCrypto === 'btc' && 'Bitcoin (BTC)'}
									{this.state.selectedCrypto === 'ltc' && 'Litecoin (LTC)'}
									{this.state.selectedCrypto === 'doge' && 'Dogecoin (DOGE)'}
								</span>
							</div>
						</div>

						<div className="admin-section">
							<div className="wallet-header">
								<h3>Wallet Configuration</h3>
								<div className="wallet-status-badges">
									{/* Bitcoin Status */}
									<div className={`wallet-status-badge ${this.state.btcWallet ? 'active' : 'inactive'} wallet-status-btc`}>
										<div className="wallet-badge-content">
											<span className="wallet-badge-icon">₿</span>
											<div className="wallet-badge-info">
												<div className="wallet-badge-name">BTC</div>
												{this.state.btcWallet && (
													<div className="wallet-badge-xpub">
														{this.state.btcWallet.hd_public_key.substring(0, 5)}...{this.state.btcWallet.hd_public_key.substring(this.state.btcWallet.hd_public_key.length - 5)}
													</div>
												)}
											</div>
										</div>
									</div>

									{/* Litecoin Status */}
									<div className={`wallet-status-badge ${this.state.ltcWallet ? 'active' : 'inactive'} wallet-status-ltc`}>
										<div className="wallet-badge-content">
											<span className="wallet-badge-icon">Ł</span>
											<div className="wallet-badge-info">
												<div className="wallet-badge-name">LTC</div>
												{this.state.ltcWallet && (
													<div className="wallet-badge-xpub">
														{this.state.ltcWallet.hd_public_key.substring(0, 5)}...{this.state.ltcWallet.hd_public_key.substring(this.state.ltcWallet.hd_public_key.length - 5)}
													</div>
												)}
											</div>
										</div>
									</div>

									{/* Dogecoin Status */}
									<div className={`wallet-status-badge ${this.state.dogeWallet ? 'active' : 'inactive'} wallet-status-doge`}>
										<div className="wallet-badge-content">
											<span className="wallet-badge-icon">Ɖ</span>
											<div className="wallet-badge-info">
												<div className="wallet-badge-name">DOGE</div>
												{this.state.dogeWallet && (
													<div className="wallet-badge-xpub">
														{this.state.dogeWallet.hd_public_key.substring(0, 5)}...{this.state.dogeWallet.hd_public_key.substring(this.state.dogeWallet.hd_public_key.length - 5)}
													</div>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>

							{this.state.walletLoading ? (
								<p>Loading wallet status...</p>
							) : (
								<div>
									<div>
										{this.state.hasWallet ? (
											<p className="success-text">✓ {this.state.selectedCrypto === 'btc' ? 'Bitcoin' : this.state.selectedCrypto === 'ltc' ? 'Litecoin' : 'Dogecoin'} wallet configured</p>
										) : (
											<p className="warning-text">⚠ No {this.state.selectedCrypto === 'btc' ? 'Bitcoin' : this.state.selectedCrypto === 'ltc' ? 'Litecoin' : 'Dogecoin'} wallet configured</p>
										)}
										<button onClick={() => this.createWallet()}>
											Create New {this.state.selectedCrypto.toUpperCase()} Wallet
										</button>
										<button
											onClick={() => this.setState({ showImportModal: true })}
											style={{ marginLeft: '10px' }}
										>
											Import Wallet
										</button>
									</div>
								</div>
							)}
						</div>

							</Accordion.Body>
						</Accordion.Item>

						{/* ========== GROUP 2: PAYMENT SETTINGS ========== */}
						<Accordion.Item eventKey="1">
							<Accordion.Header>
								<span style={{ fontSize: '18px', fontWeight: 'bold' }}>💳 Payment Settings</span>
							</Accordion.Header>
							<Accordion.Body>

						<div className="admin-section">
							<h3>Payment Settings</h3>
							<div className="setting-row" style={{ marginBottom: '15px' }}>
                <ToggleSwitch
                  label="Tips Mode"
                  isOn={this.state.tipsMode !== 'false'}
                  handleToggle={() => this.handleClickTipsMode()}
                />
							</div>

							<div className="setting-row" style={{
								display: 'flex',
								flexDirection: 'column',
								gap: '5px',
								marginBottom: '15px'
							}}>
                <ToggleSwitch
                  label="Tip Only Mode"
                  isOn={this.state.tipOnlyMode === 'true'}
                  handleToggle={() => this.handleClickTipOnlyMode()}
                />
                <small style={{color: '#666', fontSize: '13px'}}>Skip amount entry, go directly to tip selection</small>
							</div>

							<div className="setting-row" style={{
								display: 'flex',
								flexDirection: 'column',
								gap: '5px',
								marginBottom: '15px'
							}}>
                <ToggleSwitch
                  label="Pass Service Fee to Customer"
                  isOn={this.state.feePassthrough === true}
                  handleToggle={() => this.handleClickFeePassthrough()}
                />
                <small style={{color: '#666', fontSize: '13px'}}>When ON, prices are marked up so you receive full amount</small>
							</div>

							<div className="setting-row" style={{
								display: 'flex',
								flexDirection: this.state.isSmallScreen ? 'column' : 'row',
								alignItems: this.state.isSmallScreen ? 'flex-start' : 'center',
								gap: '10px',
								marginBottom: '15px'
							}}>
								<label>Discount: </label>
								<select
									value={this.state.discount || '10'}
									onChange={this.handleClickDiscount}
									style={{
										width: this.state.isSmallScreen ? '100%' : 'auto',
										maxWidth: '100%',
										padding: '8px 12px',
										fontSize: '16px',
										borderRadius: '4px',
										border: '1px solid #ccc'
									}}
								>
									<option value="10">10%</option>
									<option value="5">5%</option>
									<option value="15">15%</option>
									<option value="20">20%</option>
									<option value="25">25%</option>
									<option value="0">None</option>
								</select>
							</div>

							<div className="setting-row" style={{
								display: 'flex',
								flexDirection: this.state.isSmallScreen ? 'column' : 'row',
								alignItems: this.state.isSmallScreen ? 'flex-start' : 'center',
								gap: '10px',
								marginBottom: '15px'
							}}>
								<label>Local Currency: </label>
								<select
									value={this.state.fiatCurrency}
									onChange={this.handleSelectFiat}
									style={{
										width: this.state.isSmallScreen ? '100%' : 'auto',
										maxWidth: '100%',
										padding: '8px 12px',
										fontSize: '16px',
										borderRadius: '4px',
										border: '1px solid #ccc'
									}}
								>
									<option value="USD">$ USD - US Dollar</option>
									<option value="EUR">€ EUR - Euro</option>
									<option value="GBP">£ GBP - British Pound</option>
									<option value="JPY">¥ JPY - Japanese Yen</option>
									<option value="CAD">$ CAD - Canadian Dollar</option>
									<option value="AUD">A$ AUD - Australian Dollar</option>
									<option value="CHF">Fr CHF - Swiss Franc</option>
									<option value="CNY">¥ CNY - Chinese Yuan</option>
									<option value="INR">₹ INR - Indian Rupee</option>
									<option value="MXN">$ MXN - Mexican Peso</option>
									<option value="BRL">R$ BRL - Brazilian Real</option>
									<option value="SGD">S$ SGD - Singapore Dollar</option>
									<option value="HKD">HK$ HKD - Hong Kong Dollar</option>
									<option value="NZD">NZ$ NZD - New Zealand Dollar</option>
									<option value="SEK">kr SEK - Swedish Krona</option>
									<option value="NOK">kr NOK - Norwegian Krone</option>
									<option value="DKK">kr DKK - Danish Krone</option>
									<option value="PLN">zł PLN - Polish Zloty</option>
									<option value="ZAR">R ZAR - South African Rand</option>
									<option value="KRW">₩ KRW - South Korean Won</option>
									<option value="THB">฿ THB - Thai Baht</option>
									<option value="AED">د.إ AED - UAE Dirham</option>
									<option value="ARS">$ ARS - Argentine Peso</option>
									<option value="BDT">৳ BDT - Bangladeshi Taka</option>
									<option value="BHD">BD BHD - Bahraini Dinar</option>
									<option value="BMD">$ BMD - Bermudian Dollar</option>
									<option value="CLP">$ CLP - Chilean Peso</option>
									<option value="CZK">Kč CZK - Czech Koruna</option>
									<option value="GEL">₾ GEL - Georgian Lari</option>
									<option value="HUF">Ft HUF - Hungarian Forint</option>
									<option value="IDR">Rp IDR - Indonesian Rupiah</option>
									<option value="ILS">₪ ILS - Israeli Shekel</option>
									<option value="KWD">KD KWD - Kuwaiti Dinar</option>
									<option value="LKR">Rs LKR - Sri Lankan Rupee</option>
									<option value="MMK">K MMK - Myanmar Kyat</option>
									<option value="MYR">RM MYR - Malaysian Ringgit</option>
									<option value="NGN">₦ NGN - Nigerian Naira</option>
									<option value="PHP">₱ PHP - Philippine Peso</option>
									<option value="PKR">Rs PKR - Pakistani Rupee</option>
									<option value="SAR">SR SAR - Saudi Riyal</option>
									<option value="TRY">₺ TRY - Turkish Lira</option>
									<option value="TWD">NT$ TWD - Taiwan Dollar</option>
									<option value="UAH">₴ UAH - Ukrainian Hryvnia</option>
									<option value="VND">₫ VND - Vietnamese Dong</option>
								</select>
							</div>
						</div>

						<div className="admin-section">
							<h3>Display Settings</h3>
							<div className="setting-row">
                <ToggleSwitch 
                  label="Custom Splash Screen"
                  isOn={this.state.splash === 'custom'}
                  handleToggle={() => this.handleClickSplash()}
                />
							</div>

							<div className="setting-row">
								<div style={{display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px'}}>
									<button onClick={() => this.handleWelcomeText('top')}>
										Set Top Text {this.state.topText ? `(${this.state.topText})` : ''}
									</button>
									<button onClick={() => this.handleWelcomeText('middle')}>
										Set Middle Text {this.state.middleText ? `(${this.state.middleText})` : ''}
									</button>
									<button onClick={() => this.handleWelcomeText('bottom')}>
										Set Bottom Text {this.state.bottomText ? `(${this.state.bottomText})` : ''}
									</button>
								</div>
							</div>
						</div>

						<div className="admin-section">
							<h3>Payout Address Settings</h3>
							<p style={{fontSize: '14px', color: '#666', marginBottom: '15px'}}>
								Configure where your funds will be sent during close out. This section is password protected.
							</p>

							{!this.state.showPayoutSettings ? (
								<button onClick={() => {
									this.fetchStoreData();
									this.setState({ showPayoutSettings: true });
								}}>
									Configure Payout Addresses
								</button>
							) : (
								<div style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
									<div className="setting-row">
										<label>DOGE Payout Address:</label>
										<input
											type="text"
											value={this.state.payoutAddressDoge}
											onChange={(e) => this.setState({ payoutAddressDoge: e.target.value })}
											placeholder="DOGE address for receiving payouts"
											style={{
												width: '100%',
												padding: '8px 12px',
												fontSize: '14px',
												border: '1px solid #ddd',
												borderRadius: '4px',
												fontFamily: 'monospace'
											}}
										/>
									</div>

									<div className="setting-row">
										<label>BTC Payout Address:</label>
										<input
											type="text"
											value={this.state.payoutAddressBtc}
											onChange={(e) => this.setState({ payoutAddressBtc: e.target.value })}
											placeholder="Bitcoin address for receiving payouts"
											style={{
												width: '100%',
												padding: '8px 12px',
												fontSize: '14px',
												border: '1px solid #ddd',
												borderRadius: '4px',
												fontFamily: 'monospace'
											}}
										/>
									</div>

									<div className="setting-row">
										<label>LTC Payout Address:</label>
										<input
											type="text"
											value={this.state.payoutAddressLtc}
											onChange={(e) => this.setState({ payoutAddressLtc: e.target.value })}
											placeholder="Litecoin address for receiving payouts"
											style={{
												width: '100%',
												padding: '8px 12px',
												fontSize: '14px',
												border: '1px solid #ddd',
												borderRadius: '4px',
												fontFamily: 'monospace'
											}}
										/>
									</div>

									<div style={{display: 'flex', gap: '10px'}}>
										<button onClick={this.handleSavePayoutAddresses} style={{flex: 1}}>
											Save Payout Addresses (Password Required)
										</button>
										<button
											onClick={() => this.setState({ showPayoutSettings: false })}
											style={{flex: 1, background: '#6c757d'}}
										>
											Cancel
										</button>
									</div>
								</div>
							)}
						</div>

						<div className="admin-section">
							<h3>Employee Management</h3>
							<p style={{fontSize: '14px', color: '#666', marginBottom: '15px'}}>
								Manage employees and their cryptocurrency addresses for tip distribution.
							</p>
							<button
								onClick={() => window.location = '/employees'}
								style={{
									backgroundColor: '#28a745',
									color: 'white',
									padding: '12px 24px',
									fontSize: '16px',
									fontWeight: 'bold',
									border: 'none',
									borderRadius: '6px',
									cursor: 'pointer',
									display: 'flex',
									alignItems: 'center',
									gap: '8px'
								}}
							>
								<span style={{fontSize: '20px'}}>👥</span>
								Manage Employees
							</button>
						</div>

							</Accordion.Body>
						</Accordion.Item>

						{/* ========== GROUP 3: ORBIT REWARDS ========== */}
						<Accordion.Item eventKey="2">
							<Accordion.Header>
								<span style={{ fontSize: '18px', fontWeight: 'bold' }}>🌌 Orbit Rewards</span>
							</Accordion.Header>
							<Accordion.Body>

						{/* ========== ORBIT REWARDS SECTION ========== */}
						<div className="admin-section">
							<h3 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
								<span style={{ fontSize: '24px' }}>🌌</span>
								Orbit Rewards
							</h3>
							<p style={{fontSize: '14px', color: '#666', marginBottom: '15px'}}>
								Earn OR (Orbit Rating) and OM (Orbit Money) points for accepting crypto payments.
							</p>

							{this.state.loadingRetailerRewards ? (
								<div style={{ textAlign: 'center', padding: '20px' }}>
									<div style={{
										width: '32px',
										height: '32px',
										border: '3px solid #e9ecef',
										borderTop: '3px solid #007bff',
										borderRadius: '50%',
										animation: 'spin 1s linear infinite',
										margin: '0 auto 10px'
									}} />
									<p style={{ color: '#666', margin: 0 }}>Loading rewards...</p>
								</div>
							) : this.state.retailerRewardsError ? (
								<div style={{ textAlign: 'center', color: '#dc3545', padding: '20px' }}>
									<p>Unable to load rewards data</p>
									<button
										onClick={() => this.fetchRetailerRewards()}
										style={{
											backgroundColor: '#007bff',
											color: 'white',
											padding: '8px 16px',
											border: 'none',
											borderRadius: '4px',
											cursor: 'pointer'
										}}
									>
										Retry
									</button>
								</div>
							) : this.state.retailerRewards ? (
								<>
									{/* Summary Cards */}
									<div style={{
										display: 'grid',
										gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
										gap: '12px',
										marginBottom: '20px'
									}}>
										{/* Total OR Card */}
										<div style={{
											padding: '16px',
											background: '#f8f9fa',
											borderRadius: '8px',
											textAlign: 'center',
											border: '2px solid #e1e8ed'
										}}>
											<div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
												Total OR
											</div>
											<div style={{ fontSize: '24px', fontWeight: '600', color: '#007bff' }}>
												{this.state.retailerRewards.totalOR}
											</div>
										</div>

										{/* Total OM Card */}
										<div style={{
											padding: '16px',
											background: '#f8f9fa',
											borderRadius: '8px',
											textAlign: 'center',
											border: '2px solid #e1e8ed'
										}}>
											<div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
												Total OM
											</div>
											<div style={{ fontSize: '24px', fontWeight: '600', color: '#28a745' }}>
												{this.state.retailerRewards.totalOM.toFixed(2)}
											</div>
										</div>

										{/* Current Tier Card */}
										<div style={{
											padding: '16px',
											background: '#f8f9fa',
											borderRadius: '8px',
											textAlign: 'center',
											border: '2px solid #e1e8ed'
										}}>
											<div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
												Current Tier
											</div>
											<div style={{ fontSize: '14px', fontWeight: '600', color: '#6c757d' }}>
												{this.state.retailerRewards.currentTier}
											</div>
										</div>

										{/* Weekly Change Card */}
										<div style={{
											padding: '16px',
											background: '#f8f9fa',
											borderRadius: '8px',
											textAlign: 'center',
											border: '2px solid #e1e8ed'
										}}>
											<div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
												This Week
											</div>
											<div style={{
												fontSize: '16px',
												fontWeight: '600',
												color: this.state.retailerRewards.weeklyOMChange >= 0 ? '#28a745' : '#dc3545'
											}}>
												{this.state.retailerRewards.weeklyOMChange >= 0 ? '+' : ''}
												{this.state.retailerRewards.weeklyOMChange.toFixed(2)} OM
											</div>
										</div>
									</div>

									{/* Tier Progress Bar */}
									{this.state.retailerRewards.nextTier && (
										<div style={{ marginBottom: '20px' }}>
											<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
												<span style={{ fontSize: '12px', color: '#666' }}>
													Progress to {this.state.retailerRewards.nextTier}
												</span>
												<span style={{ fontSize: '12px', color: '#666' }}>
													{this.state.retailerRewards.orToNextTier} OR needed
												</span>
											</div>
											<div style={{
												height: '8px',
												background: '#e9ecef',
												borderRadius: '4px',
												overflow: 'hidden'
											}}>
												<div style={{
													height: '100%',
													width: `${this.state.retailerRewards.progressPercent}%`,
													background: '#007bff',
													transition: 'width 0.3s ease'
												}} />
											</div>
										</div>
									)}

									{/* How You Earn Table */}
									<div style={{ marginBottom: '20px' }}>
										<h4 style={{ fontSize: '14px', marginBottom: '10px', color: '#374151' }}>How You Earn</h4>
										<table style={{ width: '100%', fontSize: '13px', borderCollapse: 'collapse' }}>
											<tbody>
												<tr style={{ borderBottom: '1px solid #e9ecef' }}>
													<td style={{ padding: '8px 0' }}>Payment Received</td>
													<td style={{ textAlign: 'right', color: '#007bff' }}>+1 OR, +0.02 OM</td>
												</tr>
												<tr style={{ borderBottom: '1px solid #e9ecef' }}>
													<td style={{ padding: '8px 0' }}>Daily Active (3+ payments)</td>
													<td style={{ textAlign: 'right', color: '#007bff' }}>+5 OR, +0.10 OM</td>
												</tr>
												<tr style={{ borderBottom: '1px solid #e9ecef' }}>
													<td style={{ padding: '8px 0' }}>New Orbit Customer</td>
													<td style={{ textAlign: 'right', color: '#007bff' }}>+3 OR, +0.08 OM</td>
												</tr>
												<tr>
													<td style={{ padding: '8px 0' }}>100 Payments Milestone</td>
													<td style={{ textAlign: 'right', color: '#007bff' }}>+50 OR, +1.0 OM</td>
												</tr>
											</tbody>
										</table>
									</div>

									{/* Recent Activity */}
									<div>
										<h4 style={{ fontSize: '14px', marginBottom: '10px', color: '#374151' }}>Recent Activity</h4>
										{this.state.retailerRewards.recentActivity.length === 0 ? (
											<p style={{ color: '#999', textAlign: 'center', padding: '10px' }}>No activity yet - start accepting payments to earn rewards!</p>
										) : (
											<div style={{ maxHeight: '200px', overflowY: 'auto' }}>
												{this.state.retailerRewards.recentActivity.slice(0, 5).map((event, idx) => (
													<div key={idx} style={{
														display: 'flex',
														justifyContent: 'space-between',
														alignItems: 'center',
														padding: '8px 0',
														borderBottom: idx < 4 ? '1px solid #eee' : 'none'
													}}>
														<span style={{ fontSize: '13px', color: '#374151' }}>
															{this.formatEventType(event.eventType)}
														</span>
														<span style={{ fontSize: '13px', color: '#28a745', fontWeight: '500' }}>
															+{event.orAmount} OR, +{event.omAmount.toFixed(2)} OM
														</span>
													</div>
												))}
											</div>
										)}
									</div>

									{/* Refresh Button */}
									<div style={{ textAlign: 'center', marginTop: '15px' }}>
										<button
											onClick={() => this.fetchRetailerRewards()}
											style={{
												backgroundColor: 'transparent',
												color: '#007bff',
												padding: '8px 16px',
												border: '1px solid #007bff',
												borderRadius: '4px',
												cursor: 'pointer',
												fontSize: '14px'
											}}
										>
											↻ Refresh
										</button>
									</div>
								</>
							) : (
								<div style={{ textAlign: 'center', color: '#666', padding: '20px' }}>
									<p>Rewards data will appear here once you start accepting payments.</p>
								</div>
							)}
						</div>

						{/* ========== MY PERSONAL WALLETS SECTION ========== */}
						<div className="admin-section" style={{
							marginTop: '30px',
							padding: '20px',
							background: '#fff',
							borderRadius: '8px',
							border: '1px solid #dee2e6'
						}}>
							<h4 style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
								<span style={{ fontSize: '20px' }}>💼</span>
								My Personal Wallets
							</h4>
							<p style={{ color: '#666', fontSize: '14px', marginBottom: '15px' }}>
								Register your personal wallet addresses to earn customer rewards when you shop at other stores.
							</p>

							{/* Add Wallet Form */}
							<div style={{
								display: 'flex',
								gap: '10px',
								marginBottom: '20px',
								flexDirection: this.state.isSmallScreen ? 'column' : 'row',
								flexWrap: 'wrap'
							}}>
								<Form.Select
									value={this.state.newWalletCrypto}
									onChange={(e) => this.setState({ newWalletCrypto: e.target.value })}
									style={{ width: this.state.isSmallScreen ? '100%' : '120px' }}
								>
									<option value="doge">DOGE</option>
									<option value="btc">BTC</option>
									<option value="ltc">LTC</option>
								</Form.Select>
								<Form.Control
									placeholder="Wallet address"
									value={this.state.newWalletAddress}
									onChange={(e) => this.setState({ newWalletAddress: e.target.value })}
									style={{ flex: 1, minWidth: this.state.isSmallScreen ? '100%' : '200px' }}
								/>
								<Form.Control
									placeholder="Label (optional)"
									value={this.state.newWalletLabel}
									onChange={(e) => this.setState({ newWalletLabel: e.target.value })}
									style={{ width: this.state.isSmallScreen ? '100%' : '150px' }}
								/>
								<Button
									onClick={() => this.addPersonalWallet()}
									disabled={this.state.addingWallet || !this.state.newWalletAddress}
									style={{ width: this.state.isSmallScreen ? '100%' : 'auto' }}
								>
									{this.state.addingWallet ? 'Adding...' : 'Add Wallet'}
								</Button>
							</div>

							{/* Loading State */}
							{this.state.loadingWallets && (
								<p style={{ color: '#999', fontStyle: 'italic' }}>Loading wallets...</p>
							)}

							{/* Registered Wallets List */}
							{!this.state.loadingWallets && this.state.personalWallets.length > 0 && (
								<div style={{ overflowX: 'auto', maxWidth: '100%' }}>
									<Table size="sm" style={{ marginBottom: '20px' }}>
										<thead>
											<tr>
												<th>Crypto</th>
												<th>Address</th>
												{!this.state.isSmallScreen && <th>Label</th>}
												<th></th>
											</tr>
										</thead>
										<tbody>
											{this.state.personalWallets.map((wallet) => (
												<tr key={wallet.id}>
													<td>{wallet.crypto.toUpperCase()}</td>
													<td style={{ fontFamily: 'monospace', fontSize: '12px' }}>
														{wallet.address.slice(0, 8)}...{wallet.address.slice(-6)}
														{/* Show label as subtitle on mobile */}
														{this.state.isSmallScreen && wallet.label && (
															<div style={{ fontSize: '11px', color: '#6c757d', fontFamily: 'sans-serif' }}>{wallet.label}</div>
														)}
													</td>
													{!this.state.isSmallScreen && <td>{wallet.label || '-'}</td>}
													<td style={{ whiteSpace: 'nowrap' }}>
														<Button
															size="sm"
															variant="outline-danger"
															onClick={() => this.removePersonalWallet(wallet.id)}
														>
															Remove
														</Button>
													</td>
												</tr>
											))}
										</tbody>
									</Table>
								</div>
							)}

							{/* Empty State */}
							{!this.state.loadingWallets && this.state.personalWallets.length === 0 && (
								<p style={{ color: '#999', fontStyle: 'italic' }}>No wallets registered yet.</p>
							)}
						</div>

							</Accordion.Body>
						</Accordion.Item>

						{/* ========== GROUP 4: CASH OUT ========== */}
						<Accordion.Item eventKey="3">
							<Accordion.Header>
								<span style={{ fontSize: '18px', fontWeight: 'bold' }}>💰 Cash Out</span>
							</Accordion.Header>
							<Accordion.Body>

						{/* ========== SWAP SECTION ========== */}
						<div className="admin-section" style={{ textAlign: 'center' }}>
							<div
								onClick={async () => {
									await this.fetchAllBalances();
									this.setState({ showSwapModal: true });
								}}
								style={{
									cursor: 'pointer',
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									padding: '20px'
								}}
							>
								{/* Animated Swap Icon */}
								<div className="swap-icon-container">
									<svg
										width="60"
										height="60"
										viewBox="0 0 24 24"
										className="swap-arrows-animated"
									>
										<path
											d="M7.5 12L3 8l4.5-4v3h10v2h-10v3z"
											fill="#1E3A8A"
											className="arrow-up"
										/>
										<path
											d="M16.5 12l4.5 4-4.5 4v-3h-10v-2h10v-3z"
											fill="#374151"
											className="arrow-down"
										/>
									</svg>
								</div>
								<span style={{
									fontSize: '18px',
									fontWeight: '600',
									color: '#374151',
									marginTop: '10px'
								}}>
									Swap
								</span>
								<p style={{
									fontSize: '14px',
									color: '#666',
									marginTop: '8px',
									marginBottom: 0
								}}>
									Convert crypto to stablecoins or other currencies
								</p>
							</div>
						</div>

						<div className="admin-section">
							<h3>Z Report</h3>
						<div className="crypto-selector" style={{marginBottom: '20px'}}>
							<label htmlFor="z-report-crypto" style={{marginRight: '10px', fontWeight: 'bold'}}>Select Cryptocurrency:</label>
							<select
								id="z-report-crypto"
								value={this.state.selectedCrypto}
								onChange={this.handleCryptoChange}
								style={{padding: '8px 12px', fontSize: '16px', borderRadius: '4px', border: '1px solid #ddd', minWidth: '200px'}}
							>
								{/* Only show cryptos with configured wallets */}
								{this.state.dogeWallet && <option value="doge">Dogecoin (DOGE)</option>}
								{this.state.btcWallet && <option value="btc">Bitcoin (BTC)</option>}
								{this.state.ltcWallet && <option value="ltc">Litecoin (LTC)</option>}

								{/* Show message if no wallets configured */}
								{!this.state.btcWallet && !this.state.ltcWallet && !this.state.dogeWallet && (
									<option value="" disabled>No wallets configured</option>
								)}
							</select>
						</div>
							<div className="z-report">
								<div className="report-header">
									<div>{this.state.selectedCrypto.toUpperCase()} PAYOUT DETAILS</div>
									<div>{new Date().toDateString()}</div>
								</div>
								<hr/>
								{this.state.utxos === null ? (
									<div className="loading-state">
										<div className="loading-spinner"></div>
										<p>Loading wallet balance...</p>
									</div>
								) : (
									<>
										<div className="report-row" style={{fontSize: '18px', fontWeight: 'bold', backgroundColor: '#f0f8ff', padding: '12px', borderRadius: '4px'}}>
											<span>💰 Wallet Balance</span>
											<span>{this.collected().toFixed(8)} {this.state.selectedCrypto.toUpperCase()}</span>
										</div>
										<div className="report-row" style={{color: '#666', fontSize: '14px'}}>
											<span>Available UTXOs</span>
											<span>{this.state.utxos ? this.state.utxos.length : 0} outputs</span>
										</div>
										<hr/>

										{/* Breakdown of Sales vs Tips */}
										<div className="report-row" style={{fontSize: '16px', backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '4px'}}>
											<span>📊 Collection Breakdown:</span>
											<span></span>
										</div>
										<div className="report-row" style={{paddingLeft: '20px', color: '#28a745'}}>
											<span>• Sales Amount</span>
											<span>{(this.collected() - (this.state.totalTipsAvailable || 0)).toFixed(8)} {this.state.selectedCrypto.toUpperCase()}</span>
										</div>
										<div className="report-row" style={{paddingLeft: '20px', color: '#ffc107'}}>
											<span>• Tips Collected</span>
											<span>{(this.state.totalTipsAvailable || 0).toFixed(8)} {this.state.selectedCrypto.toUpperCase()}</span>
										</div>
										<hr/>
										<div className="report-row">
											<span>Service Fee ({(this.state.dijittoFeePercentage || 2.50).toFixed(2)}% of sales)</span>
											<span>{this.serviceFee().toFixed(8)} {this.state.selectedCrypto.toUpperCase()}</span>
										</div>
										{this.state.totalTipsAvailable > 0 && (
											<div className="report-row" style={{color: '#ffc107'}}>
												<span>Employee Tips (Total)</span>
												<span>{(this.state.totalTipsAvailable || 0).toFixed(8)} {this.state.selectedCrypto.toUpperCase()}</span>
											</div>
										)}
										<div className="report-row" style={{fontWeight: 'bold'}}>
											<span>Retailer Payout ({(100 - (this.state.dijittoFeePercentage || 2.50)).toFixed(2)}% of sales)</span>
											<span>{this.payoutAmount().toFixed(8)} {this.state.selectedCrypto.toUpperCase()}</span>
										</div>
										<hr/>

										{/* Warning: Payout Address Not Set */}
										{!this.hasPayoutAddressSet(this.state.selectedCrypto) && (
											<div style={{
												backgroundColor: '#fff3cd',
												border: '2px solid #ffc107',
												borderRadius: '8px',
												padding: '16px',
												marginBottom: '20px'
											}}>
												<div style={{
													fontSize: '18px',
													fontWeight: 'bold',
													color: '#856404',
													marginBottom: '10px',
													display: 'flex',
													alignItems: 'center',
													gap: '8px'
												}}>
													<span>⚠️</span>
													<span>Payout Address Not Set</span>
												</div>
												<p style={{
													color: '#856404',
													marginBottom: '12px',
													lineHeight: '1.5'
												}}>
													You must set a {this.state.selectedCrypto.toUpperCase()} payout address before processing payouts.
													<br/>
													<strong>Without an address, your funds cannot be sent!</strong>
												</p>
												<button
													onClick={() => {
														this.fetchStoreData();
														this.setState({ showPayoutSettings: true });
														// Scroll to payout settings section
														setTimeout(() => {
															const element = document.querySelector('.admin-section h3');
															if (element && element.textContent === 'Payout Address Settings') {
																element.scrollIntoView({ behavior: 'smooth', block: 'center' });
															}
														}, 100);
													}}
													style={{
														backgroundColor: '#007bff',
														color: 'white',
														padding: '10px 20px',
														fontSize: '14px',
														fontWeight: 'bold',
														border: 'none',
														borderRadius: '6px',
														cursor: 'pointer'
													}}
												>
													Set {this.state.selectedCrypto.toUpperCase()} Address Now
												</button>
											</div>
										)}

										<div className="report-actions">
											<button
												onClick={this.handleClickCloseOutDoge}
												disabled={!this.hasPayoutAddressSet(this.state.selectedCrypto)}
												style={{
													backgroundColor: this.hasPayoutAddressSet(this.state.selectedCrypto) ? '#4CAF50' : '#ccc',
													color: 'white',
													padding: '12px 24px',
													fontSize: '16px',
													fontWeight: 'bold',
													border: 'none',
													borderRadius: '6px',
													cursor: this.hasPayoutAddressSet(this.state.selectedCrypto) ? 'pointer' : 'not-allowed',
													opacity: this.hasPayoutAddressSet(this.state.selectedCrypto) ? 1 : 0.6
												}}
											>
												{this.hasPayoutAddressSet(this.state.selectedCrypto)
													? (this.state.apiKey ? 'Process Payout' : 'Close Out Flow')
													: 'Set Payout Address First'}
											</button>
											<p style={{fontSize: '12px', color: '#666', marginTop: '10px'}}>
												Close out will sweep all {this.state.selectedCrypto.toUpperCase()} from this wallet in a single transaction
											</p>
										</div>
									</>
								)}
							</div>
						</div>

							</Accordion.Body>
						</Accordion.Item>

						</Accordion>
						{/* ========== END ACCORDION ========== */}

					</Col>
				</Row>

				<style jsx>{`
					.admin-section {
						margin: 20px 0;
						padding: 20px;
						border: 1px solid #ddd;
						border-radius: 5px;
					}
					.suspension-banner {
						margin: 20px 0;
						padding: 20px;
						background-color: #f8d7da;
						border: 2px solid #f5c6cb;
						border-radius: 5px;
						color: #721c24;
					}
					.suspension-banner p {
						margin: 10px 0;
					}
					.success-text {
						color: #28a745;
						font-weight: bold;
					}
					.warning-text {
						color: #ffc107;
						font-weight: bold;
					}
					.crypto-dropdown {
						padding: 8px 12px;
						font-size: 16px;
						border: 1px solid #ddd;
						border-radius: 4px;
						background: white;
						cursor: pointer;
						min-width: 180px;
					}
					.crypto-dropdown:focus {
						outline: none;
						border-color: #007bff;
					}
					.crypto-badge {
						display: inline-flex;
						align-items: center;
						padding: 8px 16px;
						border-radius: 20px;
						margin-top: 10px;
						background: white;
						border: 2px solid;
					}
					.crypto-badge-icon {
						display: inline-flex;
						align-items: center;
						justify-content: center;
						width: 28px;
						height: 28px;
						border-radius: 50%;
						margin-right: 10px;
						font-size: 16px;
						font-weight: bold;
						color: white;
					}
					.crypto-badge-text {
						font-size: 16px;
						font-weight: 500;
					}
					.crypto-badge-btc {
						border-color: #F7931A;
						color: #F7931A;
					}
					.crypto-badge-btc .crypto-badge-icon {
						background-color: #F7931A;
					}
					.crypto-badge-ltc {
						border-color: #345D9D;
						color: #345D9D;
					}
					.crypto-badge-ltc .crypto-badge-icon {
						background-color: #345D9D;
					}
					.crypto-badge-doge {
						border-color: #C2A633;
						color: #C2A633;
					}
					.crypto-badge-doge .crypto-badge-icon {
						background-color: #C2A633;
					}
					.wallet-header {
						display: flex;
						flex-direction: column;
						gap: 15px;
					}
					.wallet-status-badges {
						display: flex;
						gap: 15px;
						margin-bottom: 15px;
						flex-wrap: wrap;
					}
					.wallet-status-badge {
						display: flex;
						align-items: center;
						padding: 12px 16px;
						border-radius: 20px;
						border: 2px solid;
						background: white;
						min-width: 140px;
						transition: all 0.3s ease;
					}
					.wallet-status-badge.inactive {
						opacity: 0.4;
						border-style: dashed;
					}
					.wallet-status-badge.active {
						opacity: 1;
						border-style: solid;
						box-shadow: 0 2px 8px rgba(0,0,0,0.1);
					}
					.wallet-badge-content {
						display: flex;
						align-items: center;
						gap: 10px;
						width: 100%;
					}
					.wallet-badge-icon {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 32px;
						height: 32px;
						border-radius: 50%;
						font-size: 18px;
						font-weight: bold;
						color: white;
						flex-shrink: 0;
					}
					.wallet-badge-info {
						display: flex;
						flex-direction: column;
						gap: 2px;
						flex: 1;
						min-width: 0;
					}
					.wallet-badge-name {
						font-size: 14px;
						font-weight: 600;
					}
					.wallet-badge-xpub {
						font-size: 11px;
						font-family: monospace;
						opacity: 0.8;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					.wallet-status-btc {
						border-color: #F7931A;
						color: #F7931A;
					}
					.wallet-status-btc .wallet-badge-icon {
						background-color: #F7931A;
					}
					.wallet-status-ltc {
						border-color: #345D9D;
						color: #345D9D;
					}
					.wallet-status-ltc .wallet-badge-icon {
						background-color: #345D9D;
					}
					.wallet-status-doge {
						border-color: #C2A633;
						color: #C2A633;
					}
					.wallet-status-doge .wallet-badge-icon {
						background-color: #C2A633;
					}
					.setting-row {
						margin: 10px 0;
						display: flex;
						align-items: center;
					}
					.radio-group {
						display: flex;
						align-items: center;
						gap: 10px;
					}
					.separator {
						color: #666;
					}
					label {
						margin-right: 10px;
						font-weight: bold;
					}
					select {
						padding: 5px;
						border-radius: 4px;
						border: 1px solid #ddd;
					}
					.z-report {
						background: white;
						padding: 20px;
						border-radius: 5px;
					}
					.report-header {
						display: flex;
						justify-content: space-between;
						margin-bottom: 10px;
					}
					.report-row {
						display: flex;
						justify-content: space-between;
						margin: 5px 0;
					}
					.report-actions {
						margin-top: 20px;
						text-align: center;
					}
					.paid-status {
						margin-top: 10px;
						text-align: center;
						background: #28a745;
						color: white;
						padding: 5px;
						border-radius: 4px;
					}
					button {
						padding: 8px 16px;
						margin: 5px;
						border: 1px solid #007bff;
						background-color: #007bff;
						color: white;
						border-radius: 4px;
						cursor: pointer;
					}
					button:hover {
						background-color: #0056b3;
					}
					.nav-bar {
						background-color: black;
						padding: 10px;
						margin-bottom: 20px;
					}
					.home-button {
						background-color: transparent;
						color: white;
						border: 1px solid white;
						border-radius: 4px;
						padding: 8px 16px;
						cursor: pointer;
						width: 100px;
					}
					.home-button:hover {
						background-color: rgba(255, 255, 255, 0.1);
					}
					.admin-header {
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-bottom: 20px;
						padding: 10px 0;
						padding-top: calc(10px + env(safe-area-inset-top, 24px));
						padding-top: calc(10px + max(env(safe-area-inset-top, 0px), 24px));
					}
					.home-button {
						padding: 8px 16px;
						background-color: #007bff;
						color: white;
						border: 1px solid #0056b3;
						border-radius: 4px;
						cursor: pointer;
						font-size: 16px;
						transition: background-color 0.2s;
					}
					.home-button:hover {
						background-color: #0056b3;
					}
					.loading-state {
						text-align: center;
						padding: 20px;
					}
					.loading-spinner {
						border: 4px solid #f3f3f3;
						border-top: 4px solid #007bff;
						border-radius: 50%;
						width: 40px;
						height: 40px;
						animation: spin 1s linear infinite;
						margin: 0 auto 15px;
					}
					@keyframes spin {
						0% { transform: rotate(0deg); }
						100% { transform: rotate(360deg); }
					}

					/* Swap arrow animations */
					.swap-arrows-animated .arrow-up {
						animation: bounceUp 1.5s ease-in-out infinite;
					}

					.swap-arrows-animated .arrow-down {
						animation: bounceDown 1.5s ease-in-out infinite;
						animation-delay: 0.75s;
					}

					@keyframes bounceUp {
						0%, 100% { transform: translateY(0); }
						50% { transform: translateY(-3px); }
					}

					@keyframes bounceDown {
						0%, 100% { transform: translateY(0); }
						50% { transform: translateY(3px); }
					}
				`}</style>

				{/* Employee Tip Distribution Modal */}
				<TipDistributionModal
					show={this.state.showTipModal}
					onHide={() => this.setState({ showTipModal: false })}
					employees={this.state.eligibleEmployees}
					crypto={this.state.selectedCrypto}
					loading={this.state.loadingEmployees}
					totalTipsAvailable={this.state.totalTipsAvailable}
					onConfirm={this.handleTipConfirm}
					onSkip={this.handleTipSkip}
				/>

				{/* Crypto Swap Modal */}
				<SwapModal
					show={this.state.showSwapModal}
					onHide={() => this.setState({ showSwapModal: false })}
					storeId={this.state.storeId}
					balances={{
						btc: this.state.btcBalance || 0,
						ltc: this.state.ltcBalance || 0,
						doge: this.state.dogeBalance || 0
					}}
					payoutAddresses={{
						btc: this.state.payoutAddressBtc,
						ltc: this.state.payoutAddressLtc,
						doge: this.state.payoutAddressDoge
					}}
					walletAddresses={{
						btc: this.state.btcWallet?.hd_public_key,
						ltc: this.state.ltcWallet?.hd_public_key,
						doge: this.state.dogeWallet?.hd_public_key
					}}
					onSwapComplete={() => this.fetchSettlementData()}
				/>

				{/* Import Wallet Modal - Step 1: Choose Cryptocurrency */}
				{this.state.showImportModal && !this.state.importCrypto && (
					<div style={{
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(0,0,0,0.5)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: 10000
					}}>
						<div style={{
							backgroundColor: 'white',
							borderRadius: '12px',
							padding: '30px',
							maxWidth: '500px',
							width: '90%',
							maxHeight: '85vh',
							overflowY: 'auto',
							boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
						}}>
							<h3 style={{ marginBottom: '20px', textAlign: 'center' }}>
								Import Wallet
							</h3>
							<p style={{ marginBottom: '25px', color: '#666', textAlign: 'center' }}>
								Which cryptocurrency wallet do you want to import?
							</p>

							<div style={{ display: 'flex', gap: '15px', marginBottom: '20px' }}>
								<button
									onClick={() => this.handleImportSelectCrypto('btc')}
									style={{
										flex: 1,
										padding: '20px',
										fontSize: '16px',
										fontWeight: 'bold',
										border: '2px solid #F7931A',
										borderRadius: '8px',
										backgroundColor: 'white',
										color: '#F7931A',
										cursor: 'pointer'
									}}
								>
									<div style={{ fontSize: '24px', marginBottom: '8px' }}>₿</div>
									Bitcoin (BTC)
								</button>

								<button
									onClick={() => this.handleImportSelectCrypto('ltc')}
									style={{
										flex: 1,
										padding: '20px',
										fontSize: '16px',
										fontWeight: 'bold',
										border: '2px solid #345D9D',
										borderRadius: '8px',
										backgroundColor: 'white',
										color: '#345D9D',
										cursor: 'pointer'
									}}
								>
									<div style={{ fontSize: '24px', marginBottom: '8px' }}>Ł</div>
									Litecoin (LTC)
								</button>

								<button
									onClick={() => this.handleImportSelectCrypto('doge')}
									style={{
										flex: 1,
										padding: '20px',
										fontSize: '16px',
										fontWeight: 'bold',
										border: '2px solid #C2A633',
										borderRadius: '8px',
										backgroundColor: 'white',
										color: '#C2A633',
										cursor: 'pointer'
									}}
								>
									<div style={{ fontSize: '24px', marginBottom: '8px' }}>Ð</div>
									Dogecoin (DOGE)
								</button>
							</div>

							<button
								onClick={() => this.setState({ showImportModal: false })}
								style={{
									width: '100%',
									padding: '12px',
									fontSize: '14px',
									border: '1px solid #ccc',
									borderRadius: '6px',
									backgroundColor: 'white',
									cursor: 'pointer'
								}}
							>
								Cancel
							</button>
						</div>
					</div>
				)}

				{/* Import Wallet Modal - Step 2: Enter Seed Phrase */}
				{this.state.showImportModal && this.state.importCrypto && (
					<div style={{
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(0,0,0,0.5)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: 10000
					}}>
						<div style={{
							backgroundColor: 'white',
							borderRadius: '12px',
							padding: '30px',
							maxWidth: '600px',
							width: '90%',
							maxHeight: '85vh',
							overflowY: 'auto',
							boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
						}}>
							<h3 style={{ marginBottom: '10px', textAlign: 'center' }}>
								Import {this.state.importCrypto.toUpperCase()} Wallet
							</h3>
							<p style={{ marginBottom: '25px', color: '#666', textAlign: 'center', fontSize: '14px' }}>
								Enter your 12-word recovery seed phrase
							</p>

							<textarea
								placeholder="word1 word2 word3 word4 word5 word6 word7 word8 word9 word10 word11 word12"
								value={this.state.importSeedPhrase}
								onChange={(e) => this.setState({ importSeedPhrase: e.target.value })}
								disabled={this.state.importing}
								autoCapitalize="none"
								autoCorrect="off"
								spellCheck={false}
								style={{
									width: '100%',
									minHeight: '120px',
									padding: '15px',
									fontSize: '14px',
									fontFamily: 'monospace',
									border: '2px solid #ddd',
									borderRadius: '8px',
									resize: 'vertical',
									marginBottom: '20px'
								}}
							/>

							<div style={{
								backgroundColor: '#FFF3CD',
								border: '1px solid #FFE69C',
								borderRadius: '6px',
								padding: '12px',
								marginBottom: '20px',
								fontSize: '13px',
								color: '#856404'
							}}>
								<strong>⚠️ Security Notice:</strong>
								<ul style={{ marginTop: '8px', marginBottom: '0', paddingLeft: '20px' }}>
									<li>Never share your seed phrase with anyone</li>
									<li>Make sure you're in a private location</li>
									<li>You'll need your store password to complete import</li>
								</ul>
							</div>

							<div style={{ display: 'flex', gap: '10px' }}>
								<button
									onClick={() => this.setState({
										showImportModal: false,
										importCrypto: null,
										importSeedPhrase: ''
									})}
									disabled={this.state.importing}
									style={{
										flex: 1,
										padding: '12px',
										fontSize: '14px',
										border: '1px solid #ccc',
										borderRadius: '6px',
										backgroundColor: 'white',
										cursor: this.state.importing ? 'not-allowed' : 'pointer',
										opacity: this.state.importing ? 0.6 : 1
									}}
								>
									Cancel
								</button>

								<button
									onClick={() => this.handleImportWallet()}
									disabled={this.state.importing || this.state.importSeedPhrase.trim().length === 0}
									style={{
										flex: 1,
										padding: '12px',
										fontSize: '14px',
										fontWeight: 'bold',
										border: 'none',
										borderRadius: '6px',
										backgroundColor: this.state.importing || this.state.importSeedPhrase.trim().length === 0 ? '#ccc' : '#007bff',
										color: 'white',
										cursor: this.state.importing || this.state.importSeedPhrase.trim().length === 0 ? 'not-allowed' : 'pointer'
									}}
								>
									{this.state.importing ? 'Importing...' : 'Import Wallet'}
								</button>
							</div>
						</div>
					</div>
				)}
			</Container>
		);
	}
}

export default Admin;
